import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Card,
  Col,
  Form,
  Tab,
  Tabs,
  Row,
  ToggleButton,
  Button,
  Overlay,
  Popover,
  Spinner,
  Modal,
} from 'react-bootstrap';
import CloseButton from 'react-bootstrap/CloseButton';
import BuySellService from '../../../services/buy-sell.service';
import { toast } from 'react-toastify';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import Loader from 'shared/common/loader';
import { userStore } from '../../../store/UserStore';
import OrderSummary from './order-summary';
import OrderConfirmation from './order-confirmation';
import '../styles.css';
import CurrencyInput from 'react-currency-input-field';
import { formatAmount, getDocumentType, toBase64 } from '../../../utils';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import KYCPopup from 'shared/common/kycPopup';
import passbookService from 'services/passbook.service';
import RedirectToast from 'shared/common/toast/redirectToast';
import { useHistory } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  BUYBACK_INVOICE_UPLOAD_MESSAGE,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
  TRADEMARK_LOGO_URL,
  BANK_TRANSFER_APPROVAL_PENDING,
} from 'constants/messages.constant';

import format from 'string-template';
import { dashboardStore } from 'store/DashboardStore';
import { Formik, Form as FormikForm, Field } from 'formik';
import * as Yup from 'yup';

import infoIco from '../../../assets/images/i-circle.svg';
import DashboardHttp from 'pages/profile/services/profile.service';
import CouponModal from 'shared/common/modal/couponModal';
import NomineeModal from 'pages/profile/components/NomineeModal';
import Redirect from 'shared/common/redirection/Redirect';

interface PropsType {
  metals: any;
  walletBalance: number;
  isDashboard: boolean;
  setSelectedMetalData?: any;
  getPassbookSummary: any;
  selectedMetalData?: any;
  getMetalTransactions?: any;
  giftMetal?: any;
  KycFraudCompleteFunction?: any;
  preselectedMetal?: string;
  prefillConfig?: {
    action?: string;
    by?: string;
    amt?: string;
    dist?: string;
    metal?: string;
    sip?: string;
    sipint?: string;
  } | null;
}

interface ExtendedRazorpayOptions extends RazorpayOptions {
  config?: {
    display: RazorpayOptions['config']['display'] & {
      blocks: Record<string, any>;
      sequence: string[];
      preferences: Record<string, any>;
    };
  };
}

const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void;
  }
}

let typingTimer;

const SUPPORTED_FORMATS = ['application/pdf'];
const FILE_SIZE = 5 * 1024 * 1024;

const BuySellMetals: React.FC<PropsType> = ({
  metals,
  walletBalance,
  isDashboard,
  setSelectedMetalData,
  getPassbookSummary,
  selectedMetalData,
  getMetalTransactions,
  giftMetal,
  KycFraudCompleteFunction,
  preselectedMetal,
  prefillConfig
}) => {
  const targetBuy = useRef(null);
  const toastId = React.useRef(null);
  const targetSell = useRef(null);
  const Razorpay = useRazorpay();
  const history = useHistory();
  const abortControllerRef = useRef<AbortController>(new AbortController());
  const [metalObject, setMetalObject] = useState<any>({});
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [quoteError, setQuoteError] = useState(false);
  const [metalCode, setMetalCode] = useState(giftMetal ? giftMetal : 'Ag');
  const [dislayOrderSummary, setDislayOrderSummary] = useState(false);
  const [quoteType, setQuoteType] = useState('amount');
  const [quoteAmount, setQuoteAmount] = useState(2100);
  const [askPrice, setAskPrice] = useState('');
  const [bidPrice, setBidPrice] = useState('');
  const [priceBreakdown, setPriceBreakdown] = useState(null);
  const [isPriceBreakdownShowBuy, setIsPriceBreakdownShowBuy] = useState(false);
  const [isPriceBreakdownShowSell, setIsPriceBreakdownShowSell] = useState(false);
  // ─── SHARED payment state – used by Buy Metals, Sell Metals, AND MultiMetal ───
  const [paymentMethod, setPaymentMethod] = useState('UPI');
  const [loading, setLoading] = useState<any>(false);
  const [isRedirect, setIsRedirect] = useState<any>(false);
  const [esignLoading, setEsignLoading] = useState(false);
  const [intervalIdQuote, setIntervalIdQuote] = useState<any>('');
  const [panBuyType, setPanBuyType] = useState<any>('');
  const [otpMeta, setOtpMeta] = useState<any>({
    otpId: '',
    otp: '',
    refType: 'B2B-BUYBACK',
    expiredAt: '',
  });

  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });

  // ─── Coupon ───────────────────────────────────────────────────────────────────
  const [showCoupon, setShowCoupon] = useState(false);
  const [couponList, setCouponList] = useState<any>([]);
  const [couponName, setCouponName] = useState('');
  const [couponLongDescription, setCouponLongDescription] = useState('');
  const [couponDisplayName, setCouponDisplayName] = useState('');
  const [showCouponBox, setShowCouponBox] = useState(false);
  // palladium issue
  const [newMetalCode, setnewMetalCode] = useState('Ag0003');

  // ─── Wallet (Buy Metals / Sell Metals) ───────────────────────────────────────
  const [useWallet, setUseWallet] = useState(false);
  const [OrderPayMethod, setOrderPayMethod] = useState([]);

  const childFunc = React.useRef(null);

  // ─── MultiMetal ──────────────────────────────────────────────────────────────
  const mmTimerRef = useRef<any>(null);
  const multiMetalPricesFetchedRef = useRef(false);
  const mmPricesAbortRef = useRef<AbortController>(new AbortController());
  const [mmCountdown, setMmCountdown] = useState('');

  const [multiMetalAmounts, setMultiMetalAmounts] = useState<Record<string, string>>({
    Au: '1000',
    Ag: '1000',
    Pt: '500',
    Pd: '',
  });
  const [multiMetalPrices, setMultiMetalPrices] = useState<Record<string, string>>({
    Au: '',
    Ag: '',
    Pt: '',
    Pd: '',
  });
  const [multiMetalTotal, setMultiMetalTotal] = useState(2500);
  // NOTE: multiMetalPaymentMethod is a LOCAL display-only state for the MM tab UI.
  // Before any payment action we sync it into the SHARED `paymentMethod` state so
  // the entire existing gateway / OTP / order flow works unchanged.
  const [multiMetalPaymentMethod, setMultiMetalPaymentMethod] = useState('UPI');
  const [useMultiWallet, setUseMultiWallet] = useState(false);
  const [multiMetalPricesLoading, setMultiMetalPricesLoading] = useState(false);

  const [quoteGenerated, setQuoteGenerated] = useState(false);
  const [isGeneratingQuote, setIsGeneratingQuote] = useState(false);

  const [isPriceBreakdownShowMultiMetal, setIsPriceBreakdownShowMultiMetal] = useState(false);
  const targetMultiMetal = useRef(null);

  const [multiMetalPriceBreakdown, setMultiMetalPriceBreakdown] = useState<any>(null);
  const [isOrderSummaryMultiMetal, setIsOrderSummaryMultiMetal] = useState(false);

  const multiMetalConfig = [
    { code: 'Au', name: 'Gold', price: multiMetalPrices['Au'] },
    { code: 'Ag', name: 'Silver', price: multiMetalPrices['Ag'] },
    { code: 'Pt', name: 'Platinum', price: multiMetalPrices['Pt'] },
    { code: 'Pd', name: 'Palladium', price: multiMetalPrices['Pd'] },
  ];

  // ── Resolve the effective MM payment method (wallet-aware) ───────────────────
  // Pure function — no side-effects — so it's safe to call at any point.
  const resolveMultiMetalPaymentMethod = (): string => {
    if (useMultiWallet) {
      if (multiMetalPriceBreakdown?.summary?.quotationTotal <= walletBalance) {
        return 'CUSTOMER_WALLET';
      }
      const base = multiMetalPaymentMethod.replace('WALLET_', '');
      return `WALLET_${base}`;
    }
    return multiMetalPaymentMethod.replace('WALLET_', ''); // strip any stale prefix
  };

  const startMmCountdown = () => {
    if (mmTimerRef.current) clearInterval(mmTimerRef.current);
    const expiry = new Date();
    expiry.setSeconds(expiry.getSeconds() + 300);

    mmTimerRef.current = setInterval(() => {
      const now = new Date();
      const diff = Math.max(0, Math.floor((expiry.getTime() - now.getTime()) / 1000));
      if (diff === 0) {
        clearInterval(mmTimerRef.current);
        setQuoteGenerated(false);
        setMmCountdown('');
        setMultiMetalPriceBreakdown(null);
      } else {
        const m = Math.floor(diff / 60);
        const s = diff % 60;
        setMmCountdown(m > 0 ? `${m}m ${s}s` : `${s}s`);
      }
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (mmTimerRef.current) clearInterval(mmTimerRef.current);
    };
  }, []);

  // ── Auto-update MM payment method when wallet toggle / total changes ──────────
  // Mirrors the exact same logic as the Buy Metals `useWallet` effect below,
  // but scoped to MULTIMETAL only so the two never interfere.
  useEffect(() => {
    if (currentTab !== 'MULTIMETAL') return;

    const base = multiMetalPaymentMethod.replace('WALLET_', ''); // 'UPI' | 'NEBK'

    if (useMultiWallet && multiMetalTotal <= walletBalance) {
      setMultiMetalPaymentMethod('CUSTOMER_WALLET');
    } else if (useMultiWallet && multiMetalTotal > walletBalance) {
      if (base === 'UPI' || multiMetalPaymentMethod === 'CUSTOMER_WALLET') {
        setMultiMetalPaymentMethod('WALLET_UPI');
      } else if (base === 'NEBK') {
        setMultiMetalPaymentMethod('WALLET_NEBK');
      }
    } else {
      // wallet unchecked — revert to plain base method
      if (
        multiMetalPaymentMethod === 'WALLET_UPI' ||
        multiMetalPaymentMethod === 'CUSTOMER_WALLET'
      ) {
        setMultiMetalPaymentMethod('UPI');
      } else if (multiMetalPaymentMethod === 'WALLET_NEBK') {
        setMultiMetalPaymentMethod('NEBK');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useMultiWallet, multiMetalTotal, walletBalance]);

  // ── Re-fetch order-pay-method summary whenever MM payment method changes ──────
  useEffect(() => {
    if (!quoteGenerated || !multiMetalPriceBreakdown) return;
    orderPaymentMethodSummaryMultiMetal(multiMetalPaymentMethod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiMetalPaymentMethod]);

  // ─── OTP auto-submit ─────────────────────────────────────────────────────────
  useEffect(() => {
    if (otpData.value?.length === 6) onSubmitOTP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpData.value]);

  const resetOtpData = () => {
    setOtpData({ value: '', ackMessage: '', ackMessageType: 'success' });
  };

  const [customerId, user, userData, selectedAccount, customer, setCustomer] =
    userStore((state: any) => [
      state.customerId,
      state.user,
      state.userData,
      state.selectedAccount,
      state.customer,
      state.setCustomer,
    ]);
  const [metalOrder] = dashboardStore((state: any) => [state.metalOrder]);

  const [quoteData, setQuoteData] = useState({
    items: [],
    type: 'SELL',
    currency: 'INR',
    ebActRef: selectedAccount.accountId,
  });

  const [item, setItem] = useState({
    itemCode: '',
    uom: 'g',
    requestedValue: null,
    requestedValueAmount: null,
    requestedValueQuantity: null,
    requestedType: 'AMOUNT',
    otherItems: [],
  });

  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });

  const [currentTab, setCurrentTab] = useState('SELL');
  const [orderData, setOrderData] = useState<any>(null);
  const [isPanUpdateRequired, setIsPanUpdateRequired] = useState(false);
  const [isKYCRequired, setIsKYCRequired] = useState(false);

  const [isOrderSummaryBuy, setIsOrderSummaryBuy] = useState(false);
  const [isOrderSummarySell, setIsOrderSummarySell] = useState(false);

  const [isOTPModalShow, setIsOTPModalShow] = useState(false);

  const [documentUpload, setDocumentUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64File, setBase64File] = useState('');

  // Keep a ref so async callbacks always see the latest tab value
  const currentTabRef = useRef(currentTab);
  useEffect(() => {
    currentTabRef.current = currentTab;
  }, [currentTab]);

  // ── Order-data side-effects ───────────────────────────────────────────────────
  useEffect(() => {
    if (orderData) {
      setDislayOrderSummary(true);
      setTimeout(() => {
        if (giftMetal) history.push('/gift');
      }, 2000);
    } else {
      setDislayOrderSummary(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  useEffect(() => {
    if (customer.companyData?.eSign?.documentStatus === 'Completed')
      setDocumentUpload(false);
  }, [customer]);

  // ── Initial metal selection ───────────────────────────────────────────────────
  useEffect((): any => {
    setMetalCode(giftMetal);
    if (!isDashboard) {
      const filteredMetal = metals.filter(
        (x: any) => x.metalCode === selectedMetalData.metal
      );
      if (filteredMetal.length > 0) {
        onChangeMetal(selectedMetalData.metal, filteredMetal[0], true);
      }
    } else {
      const selectedMetal = metals.find((x: any) => x.metalCode === metalCode);
      if (selectedMetal) {
        onChangeMetal(selectedMetal?.metalCode, selectedMetal, true);
      }
    }
    return () => {
      abortControllerRef.current.abort();
    };
    // eslint-disable-next-line
  }, []);

  useEffect((): any => {
    if (Object.keys(selectedAccount).length > 0) {
      setQuoteData((prev) => ({ ...prev, ebActRef: selectedAccount?.accountId }));
    }
    // eslint-disable-next-line
  }, [selectedAccount]);

  // ── MultiMetal helpers ────────────────────────────────────────────────────────
  const fetchMultiMetalPrices = async () => {
    // Check AND set atomically using ref (synchronous!)
    if (multiMetalPricesFetchedRef.current) {
      // console.log('MM prices already fetched, skipping');
      return;
    }

    // console.log('Fetching MM prices (setting lock)...');
    multiMetalPricesFetchedRef.current = true; // ← Set IMMEDIATELY before any async work

    setMultiMetalPricesLoading(true);

    // Abort any previous price fetch
    mmPricesAbortRef.current.abort();
    mmPricesAbortRef.current = new AbortController();

    for (const metal of metals) {
      const code = metal.metalCode;
      try {
        const payload = {
          items: [
            {
              itemCode: metal.itemCode,
              uom: 'g',
              requestedValue: null,
              requestedType: 'PRODUCT_QTY',
              otherItems: [],
            },
          ],
          type: 'SELL',
          currency: 'INR',
          ebActRef: selectedAccount.accountId,
        };
        const res: any = await BuySellService.addQuote(
          payload,
          user?.userId,
          mmPricesAbortRef.current.signal
        );
        const unitPrice =
          res?.data?.data?.payload?.unitPrice ||
          res?.data?.data?.items?.[0]?.itemBreakDown?.[0]?.summary?.unitPrice;

        // Guard: only update if still on MULTIMETAL tab
        if (unitPrice && currentTabRef.current === 'MULTIMETAL') {
          setMultiMetalPrices((prev) => ({ ...prev, [code]: unitPrice }));
        }
      } catch (e: any) {
        if (e?.name !== 'AbortError') {
          console.error(`Failed to fetch price for ${code}`, e);
        }
      }
    }

    if (currentTabRef.current === 'MULTIMETAL') {
      setMultiMetalPricesLoading(false);
    }
  };

  const onChangeMultiMetalAmount = (value: string, code: string) => {
    // Remove any decimal points and anything after them
    const cleanValue = value ? value.split('.')[0] : '';

    const updated = { ...multiMetalAmounts, [code]: cleanValue };
    setMultiMetalAmounts(updated);

    const total = Object.values(updated).reduce(
      (sum, v) => sum + (parseFloat(v?.replace(/,/g, '') || '0') || 0),
      0
    );
    setMultiMetalTotal(total);

    if (quoteGenerated) {
      setQuoteGenerated(false);
      setMultiMetalPriceBreakdown(null);
      setIsPriceBreakdownShowMultiMetal(false);
      if (mmTimerRef.current) clearInterval(mmTimerRef.current);
      setMmCountdown('');
      onRemoveCoupon(); // NEW
    }
  };

  const onGenerateMultiMetalQuote = async (skipCoupon: boolean = false) => {
    const activeMetals = Object.entries(multiMetalAmounts).filter(
      ([, v]) => parseFloat(v?.replace(/,/g, '') || '0') > 0
    );



    if (activeMetals.length === 0) {
      return toast.error('Please enter amount for at least one metal');
    }

    const invalidMetals = activeMetals.filter(
      ([, v]) => parseFloat(v?.replace(/,/g, '') || '0') < 10
    );

    if (invalidMetals.length > 0) {
      const metalNames = invalidMetals
        .map(([code]) => metalsWithCode.find((m) => m.code === code)?.name)
        .filter(Boolean)
        .join(', ');
      return toast.error(`Please add at least ₹10 for ${metalNames}`);
    }

    setIsGeneratingQuote(true);
    setMultiMetalPriceBreakdown(null);

    try {
      const items = activeMetals.map(([code, val]) => {
        const metal = metals.find((m: any) => m.metalCode === code);
        return {
          itemCode: metal.itemCode,
          uom: 'g',
          requestedValue: parseFloat(val.replace(/,/g, '')),
          requestedValueAmount: parseFloat(val.replace(/,/g, '')),
          requestedValueQuantity: null,
          requestedType: 'AMOUNT',
          otherItems: [],
        };
      });

      const payload = {
        items,
        type: 'SELL',
        currency: 'INR',
        ebActRef: selectedAccount.accountId,
        discountOrderType: 'MULTIMETAL',
        // ← Only include discountId if skipCoupon is false AND couponName exists
        ...(!skipCoupon && couponName && { discountId: couponName }),
      };

      const res: any = await BuySellService.addQuote(
        payload,
        user?.userId,
        abortControllerRef.current.signal
      );

      if (currentTabRef.current !== 'MULTIMETAL') {
        // console.log('Quote received but user switched tabs — discarding');
        return;
      }

      if (res?.status === 201 && res?.data?.data) {
        setMultiMetalPriceBreakdown(res.data.data);
        setQuoteGenerated(true);
        startMmCountdown();
        setIsPriceBreakdownShowMultiMetal(true);

        const couponWasApplied =
          !skipCoupon &&
          !!couponName &&
          (res.data.data.summary.itemTotalDiscount > 0 ||
            res.data.data.summary.itemTotalCashback > 0);
        setShowCouponBox(couponWasApplied);
      } else {
        toast.error(res?.data?.data?.title || 'Failed to generate quote');
      }
    } catch (e: any) {
      if (e?.name !== 'AbortError' && currentTabRef.current === 'MULTIMETAL') {
        toast.error(e?.data?.errors?.[0]?.title || 'Something went wrong');
      }
    } finally {
      if (currentTabRef.current === 'MULTIMETAL') {
        setIsGeneratingQuote(false);
      }
    }
  };

  /**
   * MultiMetal "Proceed" — mirrors checkPanRequirement / onHandleOrderSummary for Buy Metals.
   * Syncs resolved payment method into shared `paymentMethod` state first.
   */
  const onProceedMultiMetal = async () => {
    if (!multiMetalPriceBreakdown)
      return toast.error('Please generate a quote first.');

    if (KycFraudCompleteFunction) {
      const res = await KycFraudCompleteFunction();
      if (res) return;
    }

    const resolvedMethod = resolveMultiMetalPaymentMethod();

    // ── Wallet balance check ────────────────────────────────────────────────────
    if (
      resolvedMethod === 'CUSTOMER_WALLET' &&
      Number(walletBalance) < multiMetalPriceBreakdown.summary.quotationTotal
    ) {
      return toast.error(
        <RedirectToast
          btnLabel='Go to Wallet'
          label='Wallet balance is not enough'
          showButton
          onBtnClick={() => history.push('/wallet')}
        />,
        { closeOnClick: false }
      );
    }

    // ── PAN check ───────────────────────────────────────────────────────────────
    if (!customer?.kyc?.pan?.isVerified) {
      const panData = {
        customerId,
        amount: multiMetalPriceBreakdown.summary.quotationTotal,
      };
      try {
        const response: any = await CustomerOnboardingHttp.panThresholdCheck(
          panData
        );
        if (response.data.data.data !== 'true') {
          setIsPanUpdateRequired(true);
          setIsKYCRequired(true);
          setPanBuyType('SELL');
          return;
        }
      } catch {
        return toast.error('PAN check failed');
      }
    }

    // ── Net Banking bank-details check ──────────────────────────────────────────
    if (resolvedMethod === 'NEBK' || resolvedMethod === 'WALLET_NEBK') {
      if (
        Object.keys(customer.bankDetails).length === 0 ||
        customer.bankDetails.state === 'REJECTED' ||
        customer.bankDetails.state === 'PENDING' ||
        !customer.bankDetails.accountNo
      ) {
        return toast.error(
          <RedirectToast
            btnLabel='Go to Profile'
            label='Please verify your bank details'
            showButton
            onBtnClick={() => history.push('/profile?bank=true')}
          />,
          { closeOnClick: false }
        );
      }
    }

    // ── UPI limit check ─────────────────────────────────────────────────────────
    // ── UPI limit check ─────────────────────────────────────────────────────────
    if (resolvedMethod === 'UPI' || resolvedMethod === 'WALLET_UPI') {
      // Use existing quote data instead of regenerating — multiMetalPriceBreakdown
      // already contains meta.payLimits from the quote we just generated.
      const currentProvider = multiMetalPriceBreakdown.meta?.currentUpiProvider;
      const maxLimit = multiMetalPriceBreakdown.meta?.payLimits?.find(
        (p: any) => p.provider === currentProvider && p.method === 'UPI'
      )?.maxLimit;
      if (
        maxLimit &&
        maxLimit > 0 &&
        multiMetalPriceBreakdown.summary.quotationTotal > maxLimit
      ) {
        return toast.error(
          `UPI limit is ₹${formatAmount(maxLimit)}. Please use Net Banking.`
        );
      }
    }

    // ── Sync into shared paymentMethod so the existing gateway flow uses it ─────
    setPaymentMethod(resolvedMethod);

    await orderPaymentMethodSummaryMultiMetal(resolvedMethod);
    setIsOrderSummaryMultiMetal(true);
  };

  /**
   * Called when user confirms in the OrderConfirmation modal for MultiMetal.
   * Syncs paymentMethod and follows the EXACT same path as Buy Metals:
   *   wallet-only  → generateOtp('SELL')  → onSubmitOTP → placeOrder with OTP payload
   *   UPI / NEBK   → placeOrder           → setPaymentGatewayConfiguration
   */
  const executeMultiMetalPayment = async () => {
    if (!multiMetalPriceBreakdown) return;
    setIsOrderSummaryMultiMetal(false);

    const resolvedMethod = resolveMultiMetalPaymentMethod();
    setPaymentMethod(resolvedMethod);

    if (resolvedMethod === 'CUSTOMER_WALLET') {
      generateOtp('SELL');
      return;
    }

    try {
      setLoading(true);
      const orderPayload = {
        ebQuoteRef: multiMetalPriceBreakdown.ebQuoteRef,
        paymentMethod: resolvedMethod,
        isMultiMetalTab: true,
        discountOrderType: 'MULTIMETAL',
        ...(couponName && { discountId: couponName }),
      };

      const res: any = await BuySellService.placeOrder(
        orderPayload,
        abortControllerRef.current.signal,
        user?.userId
      );
      setLoading(false);

      if (res.status === 200 && res.data.data) {
        setPriceBreakdown(multiMetalPriceBreakdown);

        // FIX: reset MM state immediately for non-wallet path too
        setQuoteGenerated(false);
        setMultiMetalPriceBreakdown(null);
        setMmCountdown('');
        setUseMultiWallet(false);
        setMultiMetalPaymentMethod('UPI');
        if (mmTimerRef.current) clearInterval(mmTimerRef.current);

        return await setPaymentGatewayConfiguration(res.data.data);
      }
    } catch (err: any) {
      setLoading(false);
      toast.error(err?.data?.errors?.[0]?.title || 'Something went wrong');
    }
  };

  // Around line where multiMetalSummary is defined
  const multiMetalSummary = React.useMemo(() => {
    if (!multiMetalPriceBreakdown) return null;
    const lines = multiMetalPriceBreakdown.items.map((it: any) => {
      const bd = it.itemBreakDown[0];
      return {
        code: bd.metalCode,
        name: bd.name,
        qty: bd.summary.originalQuantity,
        unitPrice: bd.summary.unitPrice,
        lineAmount: it.summary.totalLineAmount,
        itemTotalAmount: it.summary.itemTotalAmount,
        gst: it.summary.itemTotalTax,
        discount: it.summary.itemTotalDiscount, // existing
        cashback: it.summary.itemTotalCashback, // ← ADD THIS
        cashbackType: bd.discount?.[0]?.cashbackType ?? null, // ← ADD THIS
        roundingDifference: bd.summary.roundingDifference,
      };
    });
    return {
      lines,
      totalGST: multiMetalPriceBreakdown.summary.itemTotalTax,
      totalDiscount: multiMetalPriceBreakdown.summary.itemTotalDiscount,
      totalCashback: multiMetalPriceBreakdown.summary.itemTotalCashback, // ← ADD THIS
      roundingDifference:
        multiMetalPriceBreakdown.summary.quotationRoundingDifference ?? 0,
      grandTotal: multiMetalPriceBreakdown.summary.quotationTotal,
    };
  }, [multiMetalPriceBreakdown]);

const restoreMetalSelection = () => {
  if (metalCode) {
    const selectedMetal = metals.find((x: any) => x.metalCode === metalCode);
    if (selectedMetal) {
      // Re-trigger the quote with the current metal
      setQuoteData({
        ...quoteData,
        items: [{
          ...item,
          itemCode: selectedMetal.itemCode,
        }]
      });
    }
  }
};


  // ─── Side modal ──────────────────────────────────────────────────────────────
const onHandleSideModal = (value) => {
  setDislayOrderSummary(false);
  if (!value) {
    getPassbookSummary(customerId, user?.userId);
    // Restore metal selection after modal closes
    setTimeout(() => {
      restoreMetalSelection();
    }, 100);
  }
};

  // ─── PAN check (Buy Metals / Sell Metals) ────────────────────────────────────
  const checkPanRequirement = async (value, type) => {
    if (KycFraudCompleteFunction) {
      const res = await KycFraudCompleteFunction();
      if (res) return;
    }
    if (
      quoteData?.type === 'SELL' &&
      paymentMethod === 'CUSTOMER_WALLET' &&
      Number(walletBalance) < priceBreakdown.summary.quotationTotal
    ) {
      setLoading(false);
      return toast.error(
        <RedirectToast
          btnLabel='Go to Wallet'
          label='Wallet balance is not enough'
          showButton
          onBtnClick={() => history.push('/wallet')}
        />,
        { closeOnClick: false }
      );
    }

    if (!customer?.kyc?.pan?.isVerified) {
      const panData = {
        customerId,
        amount: priceBreakdown?.summary?.quotationTotal,
      };
      try {
        const response: any = await CustomerOnboardingHttp.panThresholdCheck(
          panData
        );
        if (response.data.data.data == 'true' && type == 'SELL') {
          setLoading(false);
          setIsKYCRequired(false);
          if (type == 'SELL') onHandleOrderSummary(value, type);
          else checkLockinPeriod(value, type);
        } else {
          let data = { amount: priceBreakdown?.summary?.quotationTotal };
          setPanBuyType(type);
          setInitialStateItem();
          setLoading(true);
          setIsKYCRequired(true);
          try {
            const response: any = await CustomerOnboardingHttp.checkPanLimit(
              data
            );
            if (response.status === 200 && response.data) {
              setIsPanUpdateRequired(
                response.data.data.isPanVerificationRequired
              );
            }
            setLoading(false);
          } catch (error) {
            setIsPanUpdateRequired(false);
            setLoading(false);
          }
        }
      } catch (error) {
        setIsPanUpdateRequired(false);
        setLoading(false);
      }
    } else {
      setIsKYCRequired(false);
      if (type == 'SELL') onHandleOrderSummary(value, type);
      else checkLockinPeriod(value, type);
    }
  };

  const orderPaymentMethodSummary = async () => {
    try {
      const data = {
        quotationTotal: priceBreakdown.summary.quotationTotal,
        custId: customerId,
        paymentMethod: paymentMethod,
      };
      const res: any = await passbookService.getOrderPayMethodSummary(data);
      setOrderPayMethod(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const orderPaymentMethodSummaryMultiMetal = async (method?: string) => {
    try {
      const data = {
        quotationTotal: multiMetalPriceBreakdown.summary.quotationTotal,
        custId: customerId,
        paymentMethod: method ?? resolveMultiMetalPaymentMethod(),
      };
      const res: any = await passbookService.getOrderPayMethodSummary(data);
      setOrderPayMethod(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const checkLockinPeriod = async (value, type) => {
    setLoading(true);
    let quoteId = priceBreakdown?.ebQuoteRef;
    try {
      const response: any = await BuySellService.checkLockinPeriod(quoteId);
      if (response.status === 200 && response.data) {
        if (
          quoteData?.type !== 'SELL' &&
          quoteData.items[0].requestedValue &&
          customer.customerCategory === 'REGISTERED' &&
          (!customer.companyData?.eSign ||
            customer.companyData.eSign.documentStatus !== 'Completed')
        ) {
          if (customer.isBrIgnored === false) {
            setDocumentUpload(true);
            return;
          }
        }
        onHandleOrderSummary(value, type);
      }
    } catch (err: any) {
      console.error(err);
      if (err?.data?.errors[0].title) toast.error(err?.data?.errors[0].title);
    } finally {
      setLoading(false);
    }
  };

  const onHandleOrderSummary = async (value, type) => {
    if (paymentMethod === 'UPI') {
      const res: any = await BuySellService.addQuote(
        quoteData,
        user?.userId,
        abortControllerRef?.current?.signal
      );
      const maxLimit = res?.data?.data?.meta?.payLimits?.filter(
        (data: any) =>
          data.provider === res.data.data.meta.currentUpiProvider &&
          data.method === paymentMethod
      )[0].maxLimit;
      if (res.data?.data?.summary?.quotationTotal > maxLimit)
        return toast.error(
          'The maximum limit for a UPI transaction is ₹' + maxLimit
        );
    }

    if (type === 'BUY') {
      if (
        paymentMethod === 'NEBK' ||
        paymentMethod === 'NEFT' ||
        paymentMethod === 'BANK_TRANSFER'
      ) {
        if (
          Object.keys(customer.bankDetails).length === 0 ||
          customer.bankDetails.state === 'REJECTED' ||
          customer.bankDetails.state === 'PENDING' ||
          customer.bankDetails.state === 'VERIFICATION_PENDING' ||
          !customer.bankDetails.accountNo
        )
          return toast.error(
            <RedirectToast
              btnLabel='Go to Profile'
              label='Please verify your bank details'
              showButton
              onBtnClick={() => history.push('/profile?bank=true')}
            />,
            { closeOnClick: false }
          );
      }
    }

    if (type === 'SELL') {
      orderPaymentMethodSummary();
      setIsOrderSummarySell(value);
    } else {
      setIsOrderSummaryBuy(value);
    }
  };

  // ─── Metal selection ─────────────────────────────────────────────────────────
  const onChangeMetal = async (
    value: any,
    metal: any,
    isInitial: boolean = false
  ) => {
    if (toast.isActive(toastId.current)) toast.dismiss(toastId.current);
    setMetalCode(value);
    setItem({ ...item, itemCode: metal?.itemCode });

    if (quoteError) {
      setItem({
        ...item,
        requestedValue: null,
        requestedValueQuantity: null,
        requestedValueAmount: null,
      });
      setQuoteError(false);
    }

    updateQuote(
      currentTab === 'BUYBACK' ? null : quoteAmount,
      quoteType,
      metal.itemCode
    );

    if (!isDashboard && !isInitial) setSelectedMetalData(value);
    setMetalObject(metal);
    abortControllerRef.current.abort();
    onRemoveCoupon();
  };

  const onChangeBuyMetal = (value, name) => {
    setQuoteType(name);
    setQuoteAmount(value);
    let itemCopy = { ...item };
    itemCopy.requestedValue = value;
    if (name === 'amount') {
      itemCopy.requestedValueAmount = value;
      itemCopy.requestedType = 'AMOUNT';
      setItem(itemCopy);
    }
    if (name === 'grams') {
      itemCopy.requestedValueQuantity = value;
      itemCopy.requestedType = 'PRODUCT_QTY';
      setItem(itemCopy);
    }
    if (couponList.length !== 0) onRemoveCoupon();
  };

  useEffect(() => {
    if (!item.requestedValue) {
      setIsPriceBreakdownShowBuy(false);
      setIsPriceBreakdownShowSell(false);
    }
    if (item.requestedValueAmount < 100 && currentTab == 'SELL') {
      setPaymentMethod('UPI');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  useEffect(() => {
    if (currentTab === 'SELL') {
      setIsPriceBreakdownShowSell(false);
    } else if (currentTab !== 'MULTIMETAL') {
      setIsPriceBreakdownShowBuy(false);
    }
  }, [currentTab]);

  useEffect(() => {
    addQuote();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteData]);

  const fileChanged = async (event: any) => {
    setSelectedFile(event.currentTarget.files[0]);
    let file: any = await toBase64(event.currentTarget.files[0]);
    setBase64File(file);
  };

  const formatValue = (value) => {
    if (typeof value === 'string') return Number(value.replace(/,/g, ''));
    return value;
  };

  const updateQuote = (value, name, itemCode) => {
    let itemCopy = { ...item };
    if (metalCode) itemCopy.itemCode = itemCode;
    itemCopy.requestedValue = value;
    if (name === 'amount') {
      itemCopy.requestedValueAmount = value;
      itemCopy.requestedType = 'AMOUNT';
      setItem(itemCopy);
    }
    if (name === 'grams') {
      itemCopy.requestedValueQuantity = value;
      itemCopy.requestedType = 'PRODUCT_QTY';
      setItem(itemCopy);
    }
    quoteData.items = [];
    quoteData.items.push(itemCopy);
    setQuoteData({ ...quoteData, items: quoteData.items });
  };

  const onChangePaymentMethod = async (e) => {
    const { value } = e.target;
    setPaymentMethod(value);
  };

  const doneTyping = () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      quoteData.items = [];
      quoteData.items.push(item);
      setQuoteData({ ...quoteData, items: quoteData.items });
    }, 750);
  };

  const onAdditionPillClick = (value, name) => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      updateQuote(value, name, metalObject.itemCode);
    }, 10);
  };

  const time = new Date();
  time.setSeconds(time.getSeconds() + 300);
  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp: time,
    onExpire: () => addQuote(),
  });

  // ─── addQuote (single-metal) ─────────────────────────────────────────────────
  const addQuote = useCallback(async () => {
    // ─── FIX 2: Double-guard — check ref at call time AND after every await
    if (currentTabRef.current === 'MULTIMETAL') return;

    try {
      let newQuoteData = JSON.parse(JSON.stringify(quoteData));

      const currentAccountId = selectedAccount?.accountId;
      if (!currentAccountId) {
        setQuoteLoading(false);
        setAskPrice('');
        setBidPrice('');
        return;
      }
      newQuoteData.ebActRef = currentAccountId;

      if (
        quoteData.items[0].requestedValue != undefined &&
        quoteData.items[0].requestedValue != null &&
        quoteData.items[0].requestedValue != ''
      ) {
        newQuoteData.items[0].requestedValue = formatValue(
          quoteData.items[0].requestedValue
        );
      } else {
        newQuoteData.items[0].requestedValue = null;
        newQuoteData.items[0].requestedType = 'PRODUCT_QTY';
      }

      setQuoteLoading(true);
      if (isOrderSummaryBuy || isOrderSummarySell) setLoading(true);
      setPriceBreakdown(null);
      setAskPrice('Loading...');
      setBidPrice('Loading...');

      const updateddata = { ...newQuoteData, discountId: couponName };
      abortControllerRef.current = new AbortController();

      const res: any = await BuySellService.addQuote(
        couponName !== '' ? updateddata : newQuoteData,
        user?.userId,
        abortControllerRef.current.signal
      );

      // ─── FIX 2b: Re-check after the await — tab may have changed while in-flight
      if (currentTabRef.current === 'MULTIMETAL') return;

      setLoading(false);
      setQuoteLoading(false);

      // ... rest of your existing addQuote logic unchanged ...
      if (res) {
        const newTime = new Date();
        newTime.setSeconds(newTime.getSeconds() + 300);
        restart(newTime);

        if (res.status === 201 && res.data.data) {
          setQuoteError(false);
          setPriceBreakdown(res.data.data);

          let finalAmount = formatValue(
            res.data.data.items[0].itemBreakDown[0].summary.lineTotal
          );
          let finalQuantity = formatValue(
            res.data.data.items[0].itemBreakDown[0].summary.finalQuantity
          );
          let unitPrice =
            res.data.data.items[0].itemBreakDown[0].summary.unitPrice;

          if (
            quoteData.items[0].requestedValue != undefined &&
            quoteData.items[0].requestedValue != null &&
            quoteData.items[0].requestedValue != ''
          ) {
            setItem({
              ...item,
              requestedValue:
                item.requestedType !== 'AMOUNT' ? finalQuantity : finalAmount,
              requestedValueQuantity: finalQuantity,
              requestedValueAmount: finalAmount,
            });
            if (currentTabRef.current === 'SELL') {
              setAskPrice(unitPrice);
              setIsPriceBreakdownShowSell(true);
              setIsPriceBreakdownShowBuy(false);
            } else {
              setBidPrice(unitPrice);
              setIsPriceBreakdownShowSell(false);
              setIsPriceBreakdownShowBuy(true);
            }
          }
          if (currentTabRef.current === 'SELL') {
            setAskPrice(unitPrice);
          } else {
            setBidPrice(unitPrice);
          }
          if (isOrderSummaryBuy || isOrderSummarySell) {
            if (toast.isActive(toastId.current)) {
              toast.dismiss(toastId.current);
              toastId.current = toast.success('Quotation was successfully updated');
            } else {
              toastId.current = toast.success('Quotation was successfully updated');
            }
          }
        } else if (res.status === 200 && res.data.data) {
          if (res.data.data.code === 500) {
            setAskPrice(res.data.data.payload.unitPrice);
            setBidPrice(res.data.data.payload.unitPrice);
            setItem({
              ...item,
              requestedValue: null,
              requestedValueQuantity: null,
              requestedValueAmount: null,
            });
            setQuoteError(true);
            if (isOrderSummaryBuy || isOrderSummarySell) setLoading(false);
            if (toast.isActive(toastId.current)) {
              toast.dismiss(toastId.current);
              toastId.current = toast.error(res.data.data.title);
            } else {
              toastId.current = toast.error(res.data.data.title);
            }
          } else if (res.data.data.code === 400) {
            setAskPrice(res.data.data.payload.unitPrice);
            setBidPrice(res.data.data.payload.unitPrice);
            setItem({
              ...item,
              requestedValue: null,
              requestedValueQuantity: null,
              requestedValueAmount: null,
            });
            if (isOrderSummaryBuy || isOrderSummarySell) setLoading(false);
            if (res.data.data.title !== 'Request Amount/Qty not found') {
              setQuoteError(true);
              if (toast.isActive(toastId.current)) {
                toast.dismiss(toastId.current);
                toastId.current = toast.error(res.data.data.title);
              } else {
                toastId.current = toast.error(res.data.data.title);
              }
            }
          }
        }

        if (res.status == 201 && res.data.data) {
          if (res.data.data.items[0].itemBreakDown[0].discount.length > 0) {
            setShowCouponBox(true);
            toast.success('Coupon applied successfully');
          } else {
            setShowCouponBox(false);
          }
        }
      }
    } catch (err: any) {
      setAskPrice('');
      setBidPrice('');
      setQuoteLoading(false);
      if (isOrderSummaryBuy || isOrderSummarySell) setLoading(false);
      if (err?.data?.errors?.length > 0) {
        if (toast.isActive(toastId.current)) {
          toast.dismiss(toastId.current);
          toastId.current = toast.error(err.data.errors[0].title);
        } else {
          toastId.current = toast.error(err.data.errors[0].title);
        }
      }
      onRemoveCoupon();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteData]);

  // ─── handlePayment (Buy Metals / Sell Metals) ────────────────────────────────
  const handlePayment = async (payload?: any) => {
    try {
      clearInterval(intervalIdQuote);
      setIsPriceBreakdownShowSell(false);
      setIsOrderSummarySell(false);
      if (!priceBreakdown)
        return toast.error('Please fill the required details.');
      let order_payload = {
        ebQuoteRef: priceBreakdown.ebQuoteRef,
        paymentMethod: paymentMethod,
        ...payload,
      };
      return await placeOrder(order_payload);
    } catch (err: any) {
      console.log('err', err);
      if (err?.data?.errors?.length > 0)
        return toast.error(err?.data?.errors[0]?.title);
      return toast.error('Something went wrong');
    }
  };

  const getOrderDetails = async (orderRef) => {
    try {
      setLoading(true);
      const res: any = await passbookService.getOrderDetails(
        orderRef,
        user?.userId
      );
      if (
        res.status === 200 &&
        res.data.data.result &&
        res.data.data.result.length > 0
      ) {
        setOrderData(res.data.data.result[0]);
        return res.data.data.result[0];
      }
      setLoading(false);
      return;
    } catch (e: any) {
      return;
    }
  };

  const checkPaymentStatus = async (paymentId, orderId) => {
    try {
      let payload = { paymentId, orderId };
      setLoading(true);
      await BuySellService.checkPaymentStatus(
        payload,
        abortControllerRef.current.signal
      );
    } catch (error) {
    } finally {
      setLoading(false);
      await getProfile(customerId);
      let newData = await getOrderDetails(orderId);
      return await handleOrderSummaryModal(newData);
    }
  };

  /**
   * setPaymentGatewayConfiguration — UNCHANGED from original.
   * Reads `paymentMethod` state. Since we sync it before calling this function
   * (both for single-metal and multi-metal flows), it always has the right value.
   */
  const setPaymentGatewayConfiguration = async (data) => {
    setLoading(false);
    const options: ExtendedRazorpayOptions = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: '',
      currency: 'INR',
      name: 'eBullion',
      description: 'Buy Metals',
      image:
        'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
      order_id: '',
      async handler(response: any) {
        setLoading(true);
        const payload = {
          customerId: razorpay.customerId,
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          razorpayRequestBody: { amount: razorpay.amount, currency: 'INR' },
        };
        setInitialStateRazorpay();
        await checkPaymentStatus(
          response.razorpay_payment_id,
          data?.ebOrderRef
        );
      },
      prefill: {
        name: user.displayName,
        email: user.email.value,
        contact: user.mobile.value,
        method:
          paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI'
            ? 'upi'
            : 'netbanking',
      },
      modal: {
        ondismiss: () => {
          console.log('Payment popup closed.');
          window.location.reload();
        },
      } as any,
      config: {
        display: {
          language: 'en',
          blocks: {
            banks: {
              name:
                paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI'
                  ? 'Pay via UPI'
                  : 'Pay via Net Banking',
              instruments: [
                {
                  method:
                    paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI'
                      ? 'upi'
                      : 'netbanking',
                },
              ],
            },
          },
          sequence: ['block.banks'],
          preferences: { show_default_blocks: false },
        },
      },
      notes: { address: selectedAccount.billingAddress.address1 },
      theme: {
        hide_topbar: false,
        color: '#141034',
        backdrop_color: 'rgba(0, 0, 0, 0.90)',
      },
      timeout: 180,
    };

    if (paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI') {
      if (
        data.meta.payment.response.data.meta.length > 0 &&
        data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'PAYMENT_PROVIDER'
        )[0].value === 'RPY'
      ) {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
        razorpay.amount = data.meta.payment.response.data.amount;
        options.amount = (razorpay.amount * 100).toString();
        const razorPay = new Razorpay(options);
        return razorPay.open();
      } else {
        setInitialStateRazorpay();
        setLoading(false);
        await handleOrderSummaryModal(data);
      }
    }

    if (paymentMethod === 'NEBK' || paymentMethod === 'WALLET_NEBK') {
      if (data.meta.payment.response.data.meta.length > 0) {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
      }
      razorpay.amount = data.meta.payment.response.data.amount;
      options.amount = (razorpay.amount * 100).toString();
      const razorPay = new Razorpay(options);
      return razorPay.open();
    }
  };

  const buyBackPlaceOrder = async () => {
    if (
      paymentMethod === 'NEFT' ||
      (paymentMethod === 'BANK_TRANSFER' &&
        (Object.keys(customer.bankDetails).length === 0 ||
          customer.bankDetails.state === 'REJECTED' ||
          customer.bankDetails.state === 'PENDING' ||
          customer.bankDetails.state === 'VERIFICATION_PENDING' ||
          !customer.bankDetails.accountNo))
    ) {
      setLoading(false);
      return toast.error(
        <RedirectToast
          btnLabel='Go to Profile'
          label='Please verify your bank details'
          showButton
          onBtnClick={() => history.push('/profile?bank=true')}
        />,
        { closeOnClick: false }
      );
    } else {
      generateOtp('BUYBACK');
    }
  };

  const trackPurchase = (purchaseValue, currency, items) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'order_purchase', {
        value: purchaseValue,
        currency,
        items,
        customerId,
      });
      window.gtag('event', 'purchase', {
        value: purchaseValue,
        currency,
        items,
        customerId,
      });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Purchase', {
        value: purchaseValue,
        currency,
        contents: {
          quantity: items.requestedValueQuantity,
          name: items.itemCode,
          price: items.requestedValueAmount,
        },
        customerId,
      });
      window.fbq('trackCustom', 'order_purchase', {
        value: purchaseValue,
        currency,
        contents: {
          quantity: items.requestedValueQuantity,
          name: items.itemCode,
          price: items.requestedValueAmount,
        },
        customerId,
      });
    }
  };

  // ─── placeOrder (single-metal) ───────────────────────────────────────────────
  const placeOrder = async (payload) => {
    setIsOTPModalShow(false);
    try {
      if (currentTabRef.current !== 'MULTIMETAL') {
        if (
          quoteData?.type === 'SELL' &&
          paymentMethod === 'CUSTOMER_WALLET' &&
          Number(walletBalance) < priceBreakdown.summary.quotationTotal
        ) {
          setLoading(false);
          return toast.error(
            <RedirectToast
              btnLabel='Go to Wallet'
              label='Wallet balance is not enough'
              showButton
              onBtnClick={() => history.push('/wallet')}
            />,
            { closeOnClick: false }
          );
        }
        if (quoteData?.type !== 'SELL') {
          if (
            paymentMethod === 'NEFT' ||
            (paymentMethod === 'BANK_TRANSFER' &&
              (Object.keys(customer.bankDetails).length === 0 ||
                customer.bankDetails.state === 'REJECTED' ||
                customer.bankDetails.state === 'PENDING' ||
                customer.bankDetails.state === 'VERIFICATION_PENDING' ||
                !customer.bankDetails.accountNo))
          ) {
            setLoading(false);
            return toast.error(
              <RedirectToast
                btnLabel='Go to Profile'
                label='Please verify your bank details'
                showButton
                onBtnClick={() => history.push('/profile?bank=true')}
              />,
              { closeOnClick: false }
            );
          }
        }
      }

      setLoading(true);
      trackPurchase(item.requestedValueAmount, quoteData.currency, item);

      const res: any = await BuySellService.placeOrder(
        payload,
        abortControllerRef.current.signal,
        user?.userId
      );
      setLoading(false);

      if (res.status === 200 && res.data.data) {
        if (quoteData?.type == 'BUYBACK') {
          setOrderData(res.data.data);
          await getPassbookSummary(customerId, user?.userId);
          setInitialStateItem();
          if (res.data.data.status === 'INVOICE_UPLOAD_PENDING')
            return toast.info(BUYBACK_INVOICE_UPLOAD_MESSAGE, {
              autoClose: false,
              closeOnClick: false,
            });
          else if (res.data.data.status === 'BANK_TRANSFER_APPROVAL_PENDING')
            return toast.info(BANK_TRANSFER_APPROVAL_PENDING, {
              autoClose: false,
              closeOnClick: false,
            });
          else return toast.success('Order was successfully placed');
        }
        if (paymentMethod !== 'CUSTOMER_WALLET' && paymentMethod !== 'NEFT') {
          return await setPaymentGatewayConfiguration(res.data.data);
        }
        return await handleOrderSummaryModal(res.data.data);
      }
    } catch (err: any) {
      setLoading(false);
      setInitialStateItem();
      if (err?.data?.errors?.length > 0)
        return toast.error(err?.data?.errors[0]?.title);
      return toast.error('Something went wrong');
    }
  };

  const handleOrderSummaryModal = async (data) => {
    if (!isDashboard) await getMetalTransactions(0);

    if (currentTabRef.current === 'BUYBACK') {
      setLoading(false);
      setIsOTPModalShow(true);
      setOtpMeta({
        ...otpMeta,
        otp: data.meta.buybackOtp.otp,
        otpId: data.meta.buybackOtp.otpId,
        refType:
          customer.customerCategory === 'UNREGISTERED'
            ? 'B2C-BUYBACK'
            : 'B2B-BUYBACK',
      });
    } else {
      setOrderData(data);
      setLoading(false);
      setInitialStateItem();

      if (currentTabRef.current === 'MULTIMETAL') {
        setQuoteGenerated(false);
        setMultiMetalPriceBreakdown(null);
        setMmCountdown('');
        setUseMultiWallet(false);
        setMultiMetalPaymentMethod('UPI');
        setIsOrderSummaryMultiMetal(false);
        if (mmTimerRef.current) clearInterval(mmTimerRef.current);
        onRemoveCoupon(); // NEW
      }

      if (data.items?.length > 1) {
        const metalNames = data.items
          .map((i: any) => i.itemBreakDown[0]?.name)
          .filter(Boolean)
          .join(', ');
        return toast.success(
          `You have bought ${metalNames} for ₹${formatAmount(
            data.summary?.quotationTotal
          )}`
        );
      }

      return toast.success(
        'You have bought ' +
        (data.items.length > 0 &&
          data.items[0].itemBreakDown.length > 0 &&
          data.items[0].itemBreakDown[0].summary.originalQuantity.toFixed(
            4
          )) +
        'g of ' +
        data.items[0].itemBreakDown[0].name +
        ' at ₹' +
        (data.items.length > 0 &&
          data.items[0].itemBreakDown.length > 0 &&
          formatAmount(data.items[0].itemBreakDown[0].summary.unitPrice, 2)) +
        '/g for ₹' +
        formatAmount(data.summary?.quotationTotal)
      );
    }
  };

  const generateOtp = async (ruleType, otpId = null) => {
    setIsOrderSummaryBuy(false);
    setIsOrderSummarySell(false);
    let payload = user?.mobile?.value;
    try {
      setLoading(true);
      const res: any = await BuySellService.generateOtp(
        payload,
        ruleType,
        otpId,
        user?.userId
      );
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        setIsOTPModalShow(true);
        setOtpMeta({
          ...otpMeta,
          otpId: res.data.data.otpId,
          expiredAt: res.data.data.expiredAt,
        });
        return toast.success(
          'OTP has been sent to your registered mobile number.'
        );
      }
    } catch (e: any) {
      setLoading(false);
      return toast.error(e.data.errors[0].title);
    }
  };

  /**
   * onSubmitOTP — UNCHANGED routing logic.
   * For MULTIMETAL: after OTP success we call executeMultiMetalPayment().
   * paymentMethod is already synced to the resolved MM method at this point
   * (set in onProceedMultiMetal / executeMultiMetalPayment), so the gateway
   * call inside executeMultiMetalPayment works correctly.
   */
  const onSubmitOTP = async () => {
    try {
      setLoading(true);
      setOtpMeta({ ...otpMeta, otp: otpData.value });
      let payload = { otpId: otpMeta?.otpId, otp: parseInt(otpData?.value) };
      const res: any = await BuySellService.verifyOTP(payload, user?.userId);
      setLoading(false);

      if (res.status === 200 && res.data.data) {
        setOtpData({
          ...otpData,
          value: '',
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success('OTP verification successful');

        if (quoteData?.type === 'BUYBACK') {
          clearInterval(intervalIdQuote);
          setLoading(true);
          let data = {
            ebQuoteRef: priceBreakdown.ebQuoteRef,
            paymentMethod: paymentMethod,
          };
          setOtpMeta({
            otpId: '',
            otp: '',
            refType: 'B2B-BUYBACK',
            expiredAt: '',
          });
          setIsPriceBreakdownShowBuy(false);
          setIsOrderSummaryBuy(false);
          return await placeOrder(data);
        } else {
          if (currentTabRef.current === 'MULTIMETAL') {
            // For MultiMetal with CUSTOMER_WALLET: create order payload with OTP data
            setLoading(true);
            const orderPayload = {
              ebQuoteRef: multiMetalPriceBreakdown.ebQuoteRef,
              paymentMethod: paymentMethod,
              isMultiMetalTab: true,
              discountOrderType: 'MULTIMETAL', // NEW
              ...(couponName && { discountId: couponName }), // NEW
              ...payload, // Include otpId and otp
            };
            return await placeOrder(orderPayload);
          } else {
            // Buy Metals (SELL tab) - pass payload to handlePayment
            handlePayment(payload);
          }
        }
      }
    } catch (e: any) {
      setLoading(false);
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      return toast.error(e.data.errors[0].title);
    }
  };

  const handlePurchaseMetal = () => {
    if (paymentMethod === 'CUSTOMER_WALLET') {
      generateOtp('SELL');
    } else {
      handlePayment();
    }
  };

  const setInitialStateRazorpay = () => {
    setRazorpay({
      customerId,
      amount: null,
      transactionTypeId: 'eb-o-00333',
      paymentMethod: 'NEBK',
    });
  };

  // ─── Tab change ──────────────────────────────────────────────────────────────
  const onChangeTab = async (tab) => {
    resetCouponState();

    if (currentTab === 'MULTIMETAL' && tab !== 'MULTIMETAL') {
      abortControllerRef.current.abort();
      abortControllerRef.current = new AbortController();
      mmPricesAbortRef.current.abort();
      mmPricesAbortRef.current = new AbortController();

      setQuoteGenerated(false);
      setIsGeneratingQuote(false);
      setIsPriceBreakdownShowMultiMetal(false);
      setMultiMetalPriceBreakdown(null);
      setMmCountdown('');
      multiMetalPricesFetchedRef.current = false;
      if (mmTimerRef.current) clearInterval(mmTimerRef.current);
      onRemoveCoupon();
    }

    setCurrentTab(tab);

    // ─── FIX 1: MULTIMETAL has its own quote flow — never feed setQuoteData/setItem
    // into the single-metal pipeline. Early-return here prevents useEffect([item])
    // and useEffect([quoteData]) from firing addQuote at all.
    if (tab === 'MULTIMETAL') {
      setItem({
        itemCode: '',
        uom: 'g',
        requestedValue: null,
        requestedValueAmount: null,
        requestedValueQuantity: null,
        requestedType: 'AMOUNT',
        otherItems: [],
      });
      setIsPriceBreakdownShowBuy(false);
      setIsPriceBreakdownShowSell(false);
      fetchMultiMetalPrices();
      return; // ← stops here; no setQuoteData, no addQuote chain
    }

    setItem({
      ...item,
      requestedType: 'AMOUNT',
      requestedValue: tab === 'SELL' ? 2100 : null,
      requestedValueQuantity: null,
      requestedValueAmount: tab === 'SELL' ? 2100 : null,
    });
    setQuoteData({
      ...quoteData,
      items: [
        {
          ...quoteData.items[0],
          requestedValue: tab === 'SELL' ? 2100 : null,
          requestedValueQuantity: null,
          requestedValueAmount: tab === 'SELL' ? 2100 : null,
          requestedType: 'AMOUNT',
        },
      ],
      type: tab,  // never 'MULTIMETAL' reaches here now
    });

    if (tab === 'BUYBACK') {
      setIsPriceBreakdownShowSell(false);
    } else {
      setIsPriceBreakdownShowBuy(false);
    }
  };

  const setInitialStateItem = () => {
    setItem({
      itemCode: '',
      uom: 'g',
      requestedValue: null,
      requestedValueAmount: null,
      requestedValueQuantity: null,
      requestedType: '',
      otherItems: [],
    });
    setMetalCode('');
    setAskPrice('');
    setBidPrice('');
    setPriceBreakdown(null);
  };

  const onChangeValue = (e) => {
    let { name, value } = e.target;
    setOtpMeta({ ...otpMeta, [name]: Number(value) });
  };

  const resendOTP = async (otpId: number = 0) => {
    generateOtp(quoteData?.type === 'SELL' ? 'SELL' : 'BUYBACK', otpMeta.otpId);
  };

  const onKycModalClose = () => {
    setIsKYCRequired(false);
    onHandleOrderSummary(true, panBuyType);
    addQuote();
  };
  const onKycHide = () => {
    setIsKYCRequired(false);
  };

  const getItemValue = (type) => {
    return type === 'PRODUCT_QTY'
      ? item.requestedValueAmount
      : item.requestedValueQuantity;
  };

  const onItemFocus = (requestedType) => {
    setItem({
      ...item,
      itemCode: newMetalCode,
      requestedType,
      requestedValue: priceBreakdown?.items[0].itemBreakDown[0].summary
        ?.lineTotal
        ? priceBreakdown?.items[0].itemBreakDown[0].summary?.lineTotal
        : item.requestedValue,
    });
  };

  const esignCallback = (response) => {
    setEsignLoading(false);
    if ('message' in response) {
      toast.success('Document e-signed and uploaded successfully');
      getProfile(customerId);
    }
    if ('error' in response) toast.error('E-sign failed');
  };

  const trimBase64 = (file) => file.split(',')[1];

  const uploadDocument = async () => {
    if (base64File) {
      try {
        let payload = {
          companyId: customer.companyId,
          file: trimBase64(base64File),
          name: customer?.user?.firstName,
          documentName: selectedFile.name,
          email: userData.email,
          mobile: userData.phone_number,
        };
        setLoading(true);
        const res: any = await BuySellService.uploadDocument(
          payload,
          user?.userId
        );
        if (res.status == 200 && res.data) {
          let win: any = window;
          const obj = { logoUrl: TRADEMARK_LOGO_URL, callback: esignCallback };
          const leegality = new win.Leegality(obj);
          leegality.init();
          leegality.esign(res.data.data.result.signUrl);
          setEsignLoading(true);
        }
      } catch (error) {
        toast.error('Error in uploading the file');
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('File not selected');
    }
  };

  const getProfile = async (customerId: any) => {
    try {
      setLoading(true);
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data)
        setCustomer(userData.data.data.customer);
    } catch (e: any) {
      console.log(e);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // ─── Coupon helpers ───────────────────────────────────────────────────────────
  const hideCouponModal = () => setShowCoupon(false);

  const handleApplyCouponClick = async (
    value,
    discountOrderType: 'SINGLEMETAL' | 'MULTIMETAL' = 'SINGLEMETAL'
  ) => {
    await callCouponApi(value, discountOrderType);
    setShowCoupon(true);
  };

  // Fix 1: callCouponApi — guard against undefined metal
  const callCouponApi = async (
    value,
    discountOrderType: 'SINGLEMETAL' | 'MULTIMETAL' = 'SINGLEMETAL'
  ) => {
    let metalName: string;

    if (discountOrderType === 'MULTIMETAL') {
      metalName = 'ALL';
    } else {
      const prefix =
        value?.itemCode?.slice(0, 2) ||
        metalCode?.slice(0, 2) ||            // ← fallback 1: metalCode state
        metalObject?.metalCode?.slice(0, 2); // ← fallback 2: metalObject

      const matched = metalsWithCode.find((x: any) => x.code === prefix);
      if (!matched) {
        toast.error('Unable to identify metal for coupon');
        return;
      }
      metalName = matched.name.toUpperCase();
    }

    try {
      const res: any = await BuySellService.getCouponList(
        customerId,
        metalName,
        value,
        discountOrderType
      );
      if (res) {
        if (res.data.data.length === 0) {
          // no coupons
        } else {
          setCouponList(res);
          setShowCoupon(!showCoupon);
        }
      }
    } catch (error: any) {
      if (error?.data?.errors[0]?.title) {
        console.log(error?.data?.errors[0].title);
      } else {
        toast.error('Something went wrong');
      }
    }
  };


  const validateMultiMetalMinAmounts = (): boolean => {
  const activeMetals = Object.entries(multiMetalAmounts).filter(
    ([, v]) => parseFloat(v?.replace(/,/g, '') || '0') > 0
  );

  const invalidMetals = activeMetals.filter(
    ([, v]) => parseFloat(v?.replace(/,/g, '') || '0') < 10
  );

  if (invalidMetals.length > 0) {
    const metalNames = invalidMetals
      .map(([code]) => metalsWithCode.find((m) => m.code === code)?.name)
      .filter(Boolean)
      .join(', ');
    toast.error(`Please add at least ₹10 for ${metalNames}`);
    return false;
  }
  return true;
};

const onCouponApply = async (
  data,
  itemData,
  discountOrderType: 'SINGLEMETAL' | 'MULTIMETAL' = 'SINGLEMETAL'
) => {
  const metalName =
    discountOrderType === 'MULTIMETAL'
      ? 'ALL'
      : metalsWithCode.find(
          (x) => x.code === quoteData?.items[0]?.itemCode?.slice(0, 2)
        )?.name;

  const nameExists =
    couponList?.data?.data?.filter(
      (item) => item?.name?.toUpperCase() === data?.toUpperCase()
    )?.length > 0;

  if (discountOrderType === 'MULTIMETAL' && !validateMultiMetalMinAmounts()) {
    setShowCoupon(false);
    return;
  }

  try {
    if (!nameExists) {
      // ── Typed (invisible) coupon ─────────────────────────────────────────
      const validityType = discountOrderType;

      const itemDataForValidity =
        discountOrderType === 'MULTIMETAL'
          ? { requestedValueAmount: multiMetalTotal, requestedValueQuantity: null }
          : itemData;

      const res = await BuySellService.checkCouponValidity(
        customerId,
        metalName?.toUpperCase(),
        itemDataForValidity,
        data,
        validityType
      );

      const responseData = res?.data?.data;

      const isEmpty =
        responseData === null ||
        responseData === undefined ||
        responseData === 'false' ||
        (typeof responseData === 'object' &&
          !Array.isArray(responseData) &&
          Object.keys(responseData).length === 0);

      if (isEmpty) {
        toast.error('Invalid coupon code!');
        childFunc.current?.();
        setShowCoupon(false);
        return;
      }

      // Use name from response as the actual coupon code sent to API
      // Use discountDisplayName (if present) as what's shown to the user
      const canonicalName =
        typeof responseData === 'object' && responseData?.name
          ? responseData.name
          : data;

      const displayName =
        typeof responseData === 'object' && responseData?.discountDisplayName
          ? responseData.discountDisplayName
          : canonicalName; // fall back to canonical if no displayName

        const longDescription =
          typeof responseData === 'object' && responseData?.longDescription
            ? responseData.longDescription
            : null;

        setCouponName(canonicalName);
        setCouponDisplayName(displayName); // ← store display name separately
        setCouponLongDescription(longDescription ?? '');

      if (discountOrderType === 'MULTIMETAL') {
        await generateMMQuoteWithCoupon(canonicalName);
      } else {
        setQuoteData({ ...quoteData });
      }
    } else {
      // ── Listed (visible) coupon — show the coupon name as-is ────────────
      const canonicalName =
        couponList?.data?.data?.find(
          (item) => item?.name?.toUpperCase() === data?.toUpperCase()
        )?.name ?? data;

      setCouponName(canonicalName);
      setCouponDisplayName(canonicalName); // listed coupons: display = name

      if (discountOrderType === 'MULTIMETAL') {
        await generateMMQuoteWithCoupon(canonicalName);
      } else {
        setQuoteData({ ...quoteData });
      }
    }
    setShowCoupon(false);
  } catch (error) {
    console.error(error);
    toast.error('Something went wrong');
  }
};

  const generateMMQuoteWithCoupon = async (appliedCoupon: string) => {
    const activeMetals = Object.entries(multiMetalAmounts).filter(
      ([, v]) => parseFloat(v?.replace(/,/g, '') || '0') > 0
    );
    if (activeMetals.length === 0) return;

     if (!validateMultiMetalMinAmounts()) return;

    setIsGeneratingQuote(true);
    setMultiMetalPriceBreakdown(null);

    try {
      const items = activeMetals.map(([code, val]) => {
        const metal = metals.find((m: any) => m.metalCode === code);
        return {
          itemCode: metal.itemCode,
          uom: 'g',
          requestedValue: parseFloat(val.replace(/,/g, '')),
          requestedValueAmount: parseFloat(val.replace(/,/g, '')),
          requestedValueQuantity: null,
          requestedType: 'AMOUNT',
          otherItems: [],
        };
      });

      const res: any = await BuySellService.addQuote(
        {
          items,
          type: 'SELL',
          currency: 'INR',
          ebActRef: selectedAccount.accountId,
          discountOrderType: 'MULTIMETAL',
          discountId: appliedCoupon,
        },
        user?.userId,
        abortControllerRef.current.signal
      );

      // ← ADD THIS GUARD
      if (currentTabRef.current !== 'MULTIMETAL') {
        // console.log('Coupon quote received but user switched tabs — discarding');
        return;
      }

      if (res?.status === 201 && res?.data?.data) {
        setMultiMetalPriceBreakdown(res.data.data);
        setQuoteGenerated(true);
        startMmCountdown();
        setIsPriceBreakdownShowMultiMetal(true);
        const couponWasApplied =
          !!appliedCoupon &&
          (res.data.data.summary.itemTotalDiscount > 0 ||
            res.data.data.summary.itemTotalCashback > 0);
        setShowCouponBox(couponWasApplied);
        if (couponWasApplied) toast.success('Coupon applied successfully');
      } else {
        toast.error(res?.data?.data?.title || 'Failed to generate quote');
      }
    } catch (e: any) {
      if (e?.name !== 'AbortError' && currentTabRef.current === 'MULTIMETAL') {
        toast.error(e?.data?.errors?.[0]?.title || 'Something went wrong');
      }
    } finally {
      if (currentTabRef.current === 'MULTIMETAL') {
        setIsGeneratingQuote(false);
      }
    }
  };


  const resetCouponState = () => {
    setCouponName('');
    setCouponDisplayName('');
    setCouponLongDescription('');
    setCouponList([]);
    setShowCouponBox(false);
    setShowCoupon(false);
    childFunc.current?.(); // guard: may be null on first render
  };

  const onRemoveCoupon = () => {
    setCouponName('');
    setCouponDisplayName('');
    setCouponLongDescription('');
    setCouponList([]);
    setShowCouponBox(false); // ← was missing; fixes stale banner after explicit remove
    childFunc.current?.();   // guarded for safety
  };

  useEffect(() => {
    if (couponName === '') {
      setShowCouponBox(false);
      setQuoteData({ ...quoteData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponName]);

  const onResetCoupon = () => {
    setCouponList([]);
    childFunc.current();
  };

  const discount =
    priceBreakdown?.items[0]?.itemBreakDown[0]?.discount[0]?.issueDiscountType;

  const gotoSIPfunction = (sipInter) => {
    let sipDashData = {
      sipdata: {
        sipAmount: Math.floor(item?.requestedValueAmount),
        sipInterval: sipInter,
        sipItemCode: item?.itemCode,
        sipMetalType: item?.itemCode?.slice(0, 2),
      },
    };
    history.push('/sip', sipDashData);
  };

  // ── Buy Metals wallet effect — scoped to non-MULTIMETAL tabs ─────────────────
  useEffect(() => {
    if (currentTab === 'MULTIMETAL') return; // ← FIX 3b: must be FIRST line

    if (useWallet && item.requestedValueAmount <= walletBalance) {
      setPaymentMethod('CUSTOMER_WALLET');
    } else if (useWallet && item.requestedValueAmount > walletBalance) {
      if (paymentMethod === 'UPI' || paymentMethod === 'CUSTOMER_WALLET') {
        setPaymentMethod('WALLET_UPI');
      } else if (paymentMethod === 'NEBK') {
        setPaymentMethod('WALLET_NEBK');
      }
    } else {
      if (paymentMethod === 'WALLET_UPI' || paymentMethod === 'CUSTOMER_WALLET') {
        setPaymentMethod('UPI');
      } else if (paymentMethod === 'WALLET_NEBK') {
        setPaymentMethod('NEBK');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useWallet, paymentMethod, item.requestedValueAmount]);
  // ── Tab-level payment method reset ───────────────────────────────────────────
  useEffect(() => {
    if (currentTab === 'MULTIMETAL') return; // ← FIX 3a: must be FIRST line
    if (currentTab === 'BUYBACK') {
      setPaymentMethod('BANK_TRANSFER');
    } else {
      setPaymentMethod('UPI');
    }
  }, [currentTab]);

  const trackOrderFromSlug = (functionName, metalName) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', functionName, { source: 'web', metal: metalName });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', functionName, { source: 'web', metal: metalName });
    }
  };

  useEffect(() => {
    const buyMethod = JSON.parse(localStorage.getItem('buyMethod'));
    if (buyMethod && buyMethod?.metal) {
      trackOrderFromSlug(
        `${buyMethod?.utm_medium}_${buyMethod?.utm_source}_${buyMethod?.utm_campaign}`,
        buyMethod?.metal
      );
      setMetalCode(buyMethod?.metal);
      const matchedMetal = metals.find(
        (item) => item.metalCode === buyMethod?.metal
      );
      if (matchedMetal)
        onChangeMetal(matchedMetal.metalCode, matchedMetal, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const raw = localStorage.getItem('deepLinkParams');
    if (!raw) return;
    try {
      const { method, metal, amt, stg, dist } = JSON.parse(raw);
      localStorage.removeItem('deepLinkParams');
      const parsedAmt = amt ? parseInt(amt, 10) : 100;
      const parsedDist = dist ? dist.split(',').map(Number) : undefined;
      const sipInterval =
        method === 'd_sip'
          ? 'daily'
          : method === 'w_sip'
            ? 'weekly'
            : 'monthly';
      switch (method) {
        case 'd_sip':
        case 'w_sip':
        case 'm_sip': {
          let route = '/sip';
          let allocationMode = undefined;
          if (stg === '2') {
            route = '/daily-saving';
            allocationMode = 'goldSilver';
          } else if (stg === '3') {
            route = '/multimetal-sip';
            allocationMode = 'multi';
          }
          history.push(route, {
            sipdata: {
              sipAmount: parsedAmt,
              sipInterval,
              sipMetalType: metal ?? undefined,
              allocationMode,
              dist: parsedDist,
            },
          });
          break;
        }
        case 'buy_metal':
          break;
      }
    } catch (e) {
      localStorage.removeItem('deepLinkParams');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!preselectedMetal || !metals?.length) return;
    const matchedMetal = metals.find(
      (m: any) => m.metalCode === preselectedMetal
    );
    if (matchedMetal) onChangeMetal(matchedMetal.metalCode, matchedMetal, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preselectedMetal, metals]);


  useEffect(() => {
    // Wait until metals are loaded and prefillConfig is provided
    if (!prefillConfig || !metals?.length) return;

    const { action, by, amt, dist, metal, sip, sipint } = prefillConfig;

    // ── MultiMetal prefill ──────────────────────────────────────────────────
    if (action === 'multimetal' && dist) {
      const [auAmt, agAmt, ptAmt, pdAmt] = dist.split(',').map((v) => v.trim());

      // Step 1: switch tab first
      setCurrentTab('MULTIMETAL');
      currentTabRef.current = 'MULTIMETAL'; // keep ref in sync immediately

      // Step 2: let the tab render, then set amounts + fetch prices
      setTimeout(() => {
        setMultiMetalAmounts({
          Au: auAmt && auAmt !== '0' ? auAmt : '',
          Ag: agAmt && agAmt !== '0' ? agAmt : '',
          Pt: ptAmt && ptAmt !== '0' ? ptAmt : '',
          Pd: pdAmt && pdAmt !== '0' ? pdAmt : '',
        });

        const total = [auAmt, agAmt, ptAmt, pdAmt].reduce(
          (sum, v) => sum + (parseFloat(v || '0') || 0),
          0
        );
        setMultiMetalTotal(total);

        // Reset fetch lock so fetchMultiMetalPrices runs fresh
        multiMetalPricesFetchedRef.current = false;
        fetchMultiMetalPrices();
      }, 50);

      return;
    }

// ── SIP prefill — redirect to SIP page ─────────────────────────────────
if (sip === '1') {
  const parsedAmt = amt ? parseInt(amt, 10) : 1000;
  const sipInterval =
    sipint === 'daily'
      ? 'daily'
      : sipint === 'weekly'
      ? 'weekly'
      : 'monthly';

  // ── Parse dist for MultiMetal SIP ──────────────────────────────────
  // dist = "Au,Ag,Pt,Pd" comma-separated amounts
  const parsedDist = dist
    ? dist.split(',').map((v) => parseFloat(v.trim()) || 0)
    : undefined;

  const isMultiSip = parsedDist && parsedDist.some((v) => v > 0);

  history.push('/sip', {
    sipdata: {
      sipAmount: parsedAmt,
      sipInterval,
      sipMetalType: metal ?? undefined,
      // ── pass allocationMode and dist for multimetal SIP ──
      allocationMode: isMultiSip ? 'multi' : undefined,
      dist: isMultiSip ? parsedDist : undefined,
    },
  });
  return;
}

    // ── Normal Buy / Sell prefill ───────────────────────────────────────────
    if (action === 'buy' || action === 'sell') {
      const mappedTab = action === 'sell' ? 'BUYBACK' : 'SELL';
      onChangeTab(mappedTab);

      const parsedAmt = amt ? parseFloat(amt) : 1000;
      const byMethod = by === 'grams' ? 'grams' : 'amount';

      setQuoteAmount(parsedAmt);

      if (metal && metals?.length) {
        const matchedMetal = metals.find((m: any) => m.metalCode === metal);
        if (matchedMetal) {
          setMetalCode(metal);
          setMetalObject(matchedMetal);

          const itemCopy = {
            itemCode: matchedMetal.itemCode,
            uom: 'g' as const,
            requestedValue: parsedAmt,
            requestedValueAmount: byMethod === 'amount' ? parsedAmt : null,
            requestedValueQuantity: byMethod === 'grams' ? parsedAmt : null,
            requestedType: (
              byMethod === 'amount' ? 'AMOUNT' : 'PRODUCT_QTY'
            ) as 'AMOUNT' | 'PRODUCT_QTY',
            otherItems: [],
          };
          setItem(itemCopy);
          setQuoteData({
            ...quoteData,
            type: mappedTab === 'BUYBACK' ? 'BUYBACK' : 'SELL',
            items: [itemCopy],
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefillConfig, metals]);

  // ─── RENDER ──────────────────────────────────────────────────────────────────
  return (
    <>
      {isRedirect && <Redirect />}
      <Modal
        show={documentUpload}
        onHide={() => setDocumentUpload(false)}
        backdrop='static'
        keyboard={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h4>Upload Required Document(s)</h4>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{ brFile: '' }}
            validationSchema={Yup.object().shape({
              brFile: Yup.mixed()
                .nullable()
                .required('Document is required')
                .test(
                  'fileSize',
                  'File is bigger than 5MB',
                  (value) => value && value?.size <= FILE_SIZE
                )
                .test(
                  'fileType',
                  'Unsupported file format. Please upload file in PDF format',
                  (value) => value && SUPPORTED_FORMATS.includes(value?.type)
                ),
            })}
            onSubmit={() => {
              uploadDocument();
            }}
          >
            {({ errors, touched, setFieldValue }) => (
              <FormikForm>
                <Form.Group className='mb-3' controlId='entForm.comp-spoc'>
                  <Form.Label>
                    {getDocumentType(customer.customerType).type}
                  </Form.Label>
                  <small className='text-muted mx-2'>
                    {`(${getDocumentType(customer.customerType).description})`}
                  </small>
                  <Field
                    type='file'
                    placeholder=''
                    name='brFile'
                    className='form-control mt-2'
                    value={undefined}
                    onChange={(e) => {
                      fileChanged(e);
                      setFieldValue('brFile', e.currentTarget.files[0]);
                    }}
                  />
                  <div className='error'>
                    {errors.brFile && touched.brFile && (
                      <small id='my-helper-text'>
                        <img src={infoIco} alt='' />
                        {errors.brFile}
                      </small>
                    )}
                  </div>
                </Form.Group>
                <Form.Group>
                  <Button
                    className='w-100 mt-3'
                    variant='primary'
                    type='submit'
                    disabled={loading}
                  >
                    Upload
                    {loading ? <Spinner animation='border' size='sm' /> : null}
                  </Button>
                </Form.Group>
              </FormikForm>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <KYCPopup
        isKYCPopupDisplayed={isKYCRequired}
        isPanVerficationRequired={isPanUpdateRequired}
        closeModal={onKycModalClose}
        hideModal={onKycHide}
      />

      <OtpPopup
        show={isOTPModalShow}
        isLoading={loading}
        handleClose={() => {
          resetOtpData();
          setIsOTPModalShow(false);
        }}
        modalTitle={`Metal ${quoteData?.type === 'SELL' ? 'Purchase' : 'Sell'
          } Confirmation`}
        modalSubmitBtnText='Verify'
        onSubmit={() => onSubmitOTP()}
        otpLabel={format(OTP_SENT_TO_REG_MESSAGE, {
          suffixDigits: user?.mobile?.value?.slice(-4),
        })}
        enableResendTimer={true}
        resendHandler={() => {
          resetOtpData();
          resendOTP();
        }}
        otpChangeHandler={(value) => {
          setOtpData({ value, ackMessage: '', ackMessageType: 'success' });
        }}
        resendButtonText='Resend OTP'
        ackMessage={otpData.ackMessage}
        ackMessageType={otpData.ackMessageType}
        numInputs={6}
        otpValue={otpData.value}
        resendInterval={30}
      />

      {/* Sell Metals order confirmation (BUYBACK tab) */}
      <OrderConfirmation
        handleModal={(value) => {
          if (!value) clearInterval(intervalIdQuote);
          checkPanRequirement(value, 'BUY');
        }}
        isShow={isOrderSummaryBuy}
        data={priceBreakdown}
        onProceedPayment={buyBackPlaceOrder}
        minutes={minutes}
        seconds={seconds}
      />

      {/* Buy Metals order confirmation (SELL tab) */}
      <OrderConfirmation
        handleModal={(value) => {
          if (!value) clearInterval(intervalIdQuote);
          checkPanRequirement(value, 'SELL');
        }}
        isShow={isOrderSummarySell && !isKYCRequired}
        data={priceBreakdown}
        onProceedPayment={handlePurchaseMetal}
        minutes={minutes}
        seconds={seconds}
        OrderPayMethod={OrderPayMethod}
      />

      {/* MultiMetal order confirmation */}
      <OrderConfirmation
        handleModal={(value) => {
          if (!value) {
            clearInterval(intervalIdQuote);
            setIsOrderSummaryMultiMetal(false);
          }
        }}
        isShow={isOrderSummaryMultiMetal && !isKYCRequired}
        data={multiMetalPriceBreakdown}
        onProceedPayment={executeMultiMetalPayment}
        minutes={minutes}
        seconds={seconds}
        OrderPayMethod={OrderPayMethod}
      />

      {(loading || esignLoading) && <Loader />}

      <Card className='trans-card'>
        <Card.Body>
          <Tabs
            activeKey={currentTab}
            defaultActiveKey='SELL'
            id='uncontrolled-tab'
            className='custom-trade-tabs mb-3'
            onSelect={onChangeTab}
          >
            {/* ══════════════════════════════════════════ BUY METALS TAB ══ */}
            <Tab eventKey='SELL' title='Buy Metals'>
              <Form>
                <div className='d-flex justify-content-between mb-3 mt-3 tg-btns'>
                  {metalOrder.map((metal, idx) => (
                    <ToggleButton
                      key={idx}
                      id={`radio-sl-${idx}`}
                      type='radio'
                      name='radio'
                      variant='outline-warning'
                      value={metal.metalCode}
                      checked={metalCode === metal.metalCode}
                      onChange={(e) => {
                        onChangeMetal(
                          e.currentTarget.value,
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )
                        );
                        setnewMetalCode(
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )?.itemCode || ''
                        );
                      }}
                    >
                      {metalsWithCode.filter(
                        (x: any) => x.code === metal.metalCode
                      ).length > 0
                        ? metalsWithCode.filter(
                          (x: any) => x.code === metal.metalCode
                        )[0].name
                        : ''}
                    </ToggleButton>
                  ))}
                </div>

                <Form.Group className='mb-3' controlId='askPrice'>
                  <div className='d-flex justify-content-between'>
                    <Form.Label>Price</Form.Label>
                    <Form.Label
                      role='button'
                      ref={targetSell}
                      onClick={() =>
                        setIsPriceBreakdownShowSell(!isPriceBreakdownShowSell)
                      }
                    >
                      Price Breakdown
                    </Form.Label>
                    <Overlay
                      target={targetSell.current}
                      show={
                        targetSell.current &&
                        !loading &&
                        isPriceBreakdownShowSell &&
                        !quoteError &&
                        currentTab === 'SELL' &&
                        !isOrderSummaryBuy &&
                        !isOrderSummarySell &&
                        !isKYCRequired
                      }
                      placement={
                        window.innerWidth >= 576 ? 'right-start' : 'top'
                      }
                    >
                      {(props) => (
                        <Popover id='popover-basic-sell' {...props}>
                          <Popover.Body>
                            {!priceBreakdown || quoteLoading ? (
                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>₹ 0.00 /g</strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>0.0000 g</strong>
                                </p>
                                <p>
                                  Line Amount : <br />
                                  <strong>₹0.00</strong>
                                </p>
                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>₹0.00</strong>
                                </p>
                              </div>
                            ) : (
                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].itemBreakDown[0]
                                        .summary.unitPrice,
                                      2
                                    )}
                                    /g
                                  </strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>{`${priceBreakdown.items[0].itemBreakDown[0].qty.toFixed(
                                    4
                                  )} g`}</strong>
                                </p>
                                {priceBreakdown.items[0].itemBreakDown[0]
                                  .summary.adjustedQuantity !== 0 && (
                                    <p style={{ color: '#99834D' }}>
                                      Product Discount : <br />
                                      <strong
                                        style={{ color: '#99834D' }}
                                      >{`${priceBreakdown.items[0].itemBreakDown[0].summary.adjustedQuantity.toFixed(
                                        4
                                      )} g`}</strong>
                                    </p>
                                  )}
                                <p>
                                  Line Amount : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].summary
                                        .totalLineAmount
                                    )}
                                  </strong>
                                </p>
                                {priceBreakdown.summary.itemTotalDiscount !==
                                  0 && (
                                    <p style={{ color: '#99834D' }}>
                                      Discount : <br />
                                      <strong style={{ color: '#99834D' }}>
                                        ₹{' '}
                                        {formatAmount(
                                          priceBreakdown.summary.itemTotalDiscount
                                        )}
                                      </strong>
                                    </p>
                                  )}
                                {priceBreakdown.summary.itemTotalTax !== 0 && (
                                  <p>
                                    GST : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.itemTotalTax
                                      )}
                                    </strong>
                                  </p>
                                )}
                                {priceBreakdown.summary.quotationTax !== 0 && (
                                  <p>
                                    TCS : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.quotationTax
                                      )}
                                    </strong>
                                  </p>
                                )}
                                {priceBreakdown.summary
                                  .quotationRoundingDifference !== 0 && (
                                    <p>
                                      Rounding Difference : <br />
                                      <strong>
                                        {priceBreakdown.summary
                                          .quotationRoundingDifference > 0
                                          ? '₹ ' +
                                          formatAmount(
                                            priceBreakdown.summary
                                              .quotationRoundingDifference
                                          )
                                          : '- ₹ ' +
                                          formatAmount(
                                            priceBreakdown.summary
                                              .quotationRoundingDifference * -1
                                          )}
                                      </strong>
                                    </p>
                                  )}
                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.summary.quotationTotal
                                    )}
                                  </strong>
                                </p>
                              </div>
                            )}
                          </Popover.Body>
                        </Popover>
                      )}
                    </Overlay>
                  </div>
                  <Form.Control
                    type='text'
                    value={
                      askPrice
                        ? Number(askPrice)
                          ? `₹ ${formatAmount(Number(askPrice), 2)}`
                          : askPrice
                        : ''
                    }
                    className='text-right'
                    disabled
                  />
                  {askPrice ? (
                    <Form.Text id='askPrice' muted>
                      Refreshes in {minutes > 0 ? `${minutes}m ` : ``}
                      {`${seconds}s`}
                    </Form.Text>
                  ) : null}
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className='mb-1' controlId='amountInRupees'>
                      <Form.Label>Amount in Rupees</Form.Label>
                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(askPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='amount'
                        value={getItemValue('PRODUCT_QTY')}
                        onFocus={() => onItemFocus('AMOUNT')}
                        onWheel={(e: any) => e.target.blur()}
                        onValueChange={onChangeBuyMetal}
                        onKeyUp={doneTyping}
                        decimalsLimit={2}
                        decimalScale={2}
                        placeholder='₹ 0.00'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        prefix='₹ '
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className='mb-1' controlId='amountInGrams'>
                      <Form.Label>Quantity in grams</Form.Label>
                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(askPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='grams'
                        value={getItemValue('AMOUNT')}
                        onFocus={() => onItemFocus('PRODUCT_QTY')}
                        onWheel={(e: any) => e.target.blur()}
                        onValueChange={onChangeBuyMetal}
                        onKeyUp={doneTyping}
                        decimalsLimit={4}
                        decimalScale={4}
                        placeholder='0.0000 g'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        suffix=' g'
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className='form-text text-muted mt-1 mb-1'>
                  You can start at just ₹10
                </div>
                <Row>
                  <div className='d-flex justify-content-between mb-3 mt-1 tg-btns'>
                    {item.requestedType === 'PRODUCT_QTY'
                      ? [1, 5, 10, 25].map((quantity, idx) => (
                        <Button
                          key={idx}
                          variant='outline-warning'
                          disabled={quoteLoading}
                          onClick={() =>
                            onAdditionPillClick(
                              item.requestedValueQuantity
                                ? formatAmount(
                                  Number(item.requestedValueQuantity) +
                                  Number(quantity),
                                  4
                                )
                                : formatAmount(Number(quantity), 4),
                              'grams'
                            )
                          }
                        >
                          + {quantity}g
                        </Button>
                      ))
                      : [2100, 5100, 11000, 21000].map((amount, idx) => (
                        <Button
                          key={idx}
                          disabled={quoteLoading}
                          variant='outline-warning'
                          onClick={() =>
                            onAdditionPillClick(Number(amount), 'amount')
                          }
                        >
                          ₹ {amount}
                        </Button>
                      ))}
                  </div>
                </Row>

                {showCouponBox ? (
                  <div className='remove-coupon-div'>
                    <div className='remove-coupon-div-text'>

                      <span>Coupon applied: {couponDisplayName}</span>

                      {couponLongDescription && (
                        <span>{couponLongDescription}</span>
                      )}

                      {discount != null && (() => {
                        const discountItem = priceBreakdown?.items[0]?.itemBreakDown[0]?.discount[0];

                        if (discount === 'PRODUCT_QTY') {
                          return (
                            <span>
                              You get: {discountItem?.value.toFixed(4)} g of {discountItem?.DiscountMetal}
                            </span>
                          );
                        }

                        if (discountItem?.cashbackType === 'CASHBACK') {
                          return <span>Cashback: ₹{discountItem?.value.toFixed(2)}</span>;
                        }

                        return <span>You save: ₹{discountItem?.value.toFixed(2)}</span>;
                      })()}

                    </div>
                    <CloseButton
                      onClick={() => {
                        onRemoveCoupon();
                        toast.info('The coupon has been removed');
                      }}
                    />
                  </div>
                ) : item.requestedValueAmount ? (
                  <div className='apply-coupon-text'>
                    <a
                      onClick={() =>
                        handleApplyCouponClick(item, 'SINGLEMETAL')
                      }
                    >
                      <span>Apply coupon code</span>
                    </a>
                  </div>
                ) : null}

                <CouponModal
                  childFunc={childFunc}
                  isCouponPopupDisplayed={showCoupon}
                  isPanVerficationRequired={isPanUpdateRequired}
                  closeModal={hideCouponModal}
                  hideModal={hideCouponModal}
                  couponList={couponList}
                  onCouponApply={(data) => {
                    if (currentTab === 'MULTIMETAL') {
                      const firstActive = Object.entries(
                        multiMetalAmounts
                      ).find(
                        ([, v]) => parseFloat(v?.replace(/,/g, '') || '0') > 0
                      );
                      if (!firstActive) return;
                      const [code, val] = firstActive;
                      const metal = metals.find(
                        (m: any) => m.metalCode === code
                      );
                      const itemForCoupon = {
                        itemCode: metal.itemCode,
                        uom: 'g',
                        requestedValue: parseFloat(val.replace(/,/g, '')),
                        requestedValueAmount: parseFloat(val.replace(/,/g, '')),
                        requestedValueQuantity: null,
                        requestedType: 'AMOUNT',
                        otherItems: [],
                      };
                      onCouponApply(data, itemForCoupon, 'MULTIMETAL');
                    } else {
                      onCouponApply(data, item, 'SINGLEMETAL');
                    }
                  }}
                  onResetCoupon={onResetCoupon}
                />

                <div
                  className='container_checkbox form-control mb-2'
                  style={{ backgroundColor: '#eae6dd' }}
                >
                  <Form.Check
                    type='checkbox'
                    label={
                      <span
                        style={{ fontSize: '14px', backgroundColor: '#eae6dd' }}
                      >
                        Wallet Money —{' '}
                        <span style={{ color: '#99834d', fontWeight: '700' }}>
                          ₹ {formatAmount(walletBalance || 0)}
                        </span>
                      </span>
                    }
                    name='pgwallet'
                    onClick={() => setUseWallet(!useWallet)}
                    disabled={
                      walletBalance <= 0 ||
                      Number(askPrice) === 0 ||
                      customer.active === 'DISABLED' ||
                      Object.keys(selectedAccount).length === 0 ||
                      selectedAccount.active === 'DISABLED' ||
                      quoteError
                    }
                  />
                </div>

                {(useWallet && item.requestedValueAmount > walletBalance) ||
                  !useWallet ? (
                  <Form.Group className='mb-3' controlId='paymentMethod'>
                    <Form.Label>Payment Method</Form.Label>
                    <Form.Select
                      aria-label='Default select example'
                      onChange={onChangePaymentMethod}
                      disabled={!priceBreakdown}
                    >
                      <option value='UPI'>UPI</option>
                      {getItemValue('PRODUCT_QTY') >= 100 && (
                        <option value='NEBK'>Net Banking</option>
                      )}
                    </Form.Select>
                  </Form.Group>
                ) : null}

                <div className='d-grid mb-3 gap-2'>
                  <Button
                    variant='primary'
                    disabled={
                      Number(askPrice) === 0 ||
                      customer.active === 'DISABLED' ||
                      Object.keys(selectedAccount).length === 0 ||
                      selectedAccount.active === 'DISABLED' ||
                      quoteError
                    }
                    onClick={() => checkPanRequirement(true, 'SELL')}
                    style={{
                      padding: '8px 16px',
                      fontSize: '14px',
                      lineHeight: '1.4',
                    }}
                  >
                    Buy One Time
                  </Button>
                  {!useWallet && (
                    <Button
                      variant='primary'
                      disabled={
                        Number(askPrice) === 0 ||
                        customer.active === 'DISABLED' ||
                        Object.keys(selectedAccount).length === 0 ||
                        selectedAccount.active === 'DISABLED' ||
                        quoteError
                      }
                      onClick={() => gotoSIPfunction('daily')}
                      style={{
                        padding: '8px 16px',
                        fontSize: '14px',
                        lineHeight: '1.4',
                      }}
                    >
                      Create SIP
                      <span
                        style={{
                          fontSize: '11px',
                          fontWeight: 400,
                          opacity: 0.8,
                          marginLeft: '6px',
                        }}
                      >
                        Daily · Weekly · Monthly
                      </span>
                    </Button>
                  )}
                </div>
              </Form>
            </Tab>

            {/* ══════════════════════════════════════════ SELL METALS TAB ══ */}
            <Tab eventKey='BUYBACK' title='Sell Metals'>
              <Form>
                <div className='d-flex justify-content-between mb-3 mt-3 tg-btns'>
                  {metalOrder.map((metal, idx) => (
                    <ToggleButton
                      key={idx}
                      id={`radio-bb-${idx}`}
                      type='radio'
                      name='radio'
                      variant='outline-warning'
                      value={metal.metalCode}
                      checked={metalCode === metal.metalCode}
                      onChange={(e) => {
                        onChangeMetal(
                          e.currentTarget.value,
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )
                        );
                        setnewMetalCode(
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )?.itemCode || ''
                        );
                      }}
                    >
                      {metalsWithCode.filter(
                        (x: any) => x.code === metal.metalCode
                      ).length > 0
                        ? metalsWithCode.filter(
                          (x: any) => x.code === metal.metalCode
                        )[0].name
                        : ''}
                    </ToggleButton>
                  ))}
                </div>

                <Form.Group className='mb-3' controlId='bidPrice'>
                  <div className='d-flex justify-content-between'>
                    <Form.Label>Price</Form.Label>
                    <Form.Label
                      role='button'
                      ref={targetBuy}
                      onClick={() =>
                        setIsPriceBreakdownShowBuy(!isPriceBreakdownShowBuy)
                      }
                    >
                      Price Breakdown
                    </Form.Label>
                    <Overlay
                      target={targetBuy.current}
                      show={
                        targetBuy.current &&
                        !quoteError &&
                        !loading &&
                        currentTab === 'BUYBACK' &&
                        isPriceBreakdownShowBuy &&
                        !isOrderSummaryBuy &&
                        !isOrderSummarySell
                      }
                      placement={
                        window.innerWidth >= 576 ? 'right-start' : 'top'
                      }
                    >
                      {(props) => (
                        <Popover id='popover-basic-buyback' {...props}>
                          <Popover.Body>
                            {priceBreakdown && !quoteLoading ? (
                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].itemBreakDown[0]
                                        .summary.unitPrice,
                                      2
                                    )}
                                    /g
                                  </strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>{`${priceBreakdown.items[0].itemBreakDown[0].summary.originalQuantity.toFixed(
                                    4
                                  )} g`}</strong>
                                </p>
                                {priceBreakdown.items[0].itemBreakDown[0]
                                  .summary.adjustedQuantity !== 0 && (
                                    <p style={{ color: '#99834D' }}>
                                      Product Discount : <br />
                                      <strong
                                        style={{ color: '#99834D' }}
                                      >{`${priceBreakdown.items[0].itemBreakDown[0].summary.adjustedQuantity.toFixed(
                                        4
                                      )} g`}</strong>
                                    </p>
                                  )}
                                <p>
                                  Line Amount : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].summary
                                        .totalLineAmount
                                    )}
                                  </strong>
                                </p>
                                {priceBreakdown.items[0].itemBreakDown[0]
                                  .summary.metalDiscountQty !== 0 && (
                                    <p>
                                      Discount Quantity : <br />
                                      <strong>{`${priceBreakdown.items[0].itemBreakDown[0].summary.metalDiscountQty.toFixed(
                                        4
                                      )} g`}</strong>
                                    </p>
                                  )}
                                {priceBreakdown.summary.itemTotalDiscount !==
                                  0 && (
                                    <p style={{ color: '#99834D' }}>
                                      Discount : <br />
                                      <strong style={{ color: '#99834D' }}>
                                        ₹{' '}
                                        {formatAmount(
                                          priceBreakdown.summary.itemTotalDiscount
                                        )}
                                      </strong>
                                    </p>
                                  )}
                                {priceBreakdown.summary.itemTotalTax !== 0 && (
                                  <p>
                                    GST : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.itemTotalTax
                                      )}
                                    </strong>
                                  </p>
                                )}
                                {priceBreakdown.summary.quotationTax !== 0 && (
                                  <p>
                                    TDS : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.quotationTax
                                      )}
                                    </strong>
                                  </p>
                                )}
                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.summary.quotationTotal
                                    )}
                                  </strong>
                                </p>
                              </div>
                            ) : (
                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>₹ 0.00 /g</strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>0.0000 g</strong>
                                </p>
                                <p>
                                  Line Amount : <br />
                                  <strong>₹0.00</strong>
                                </p>
                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>₹0.00</strong>
                                </p>
                              </div>
                            )}
                          </Popover.Body>
                        </Popover>
                      )}
                    </Overlay>
                  </div>
                  <Form.Control
                    type='text'
                    value={
                      bidPrice
                        ? Number(bidPrice)
                          ? `₹ ${formatAmount(Number(bidPrice), 2)}`
                          : bidPrice
                        : ''
                    }
                    className='text-right'
                    disabled
                  />
                  {bidPrice ? (
                    <Form.Text id='bidPrice' muted>
                      Refreshes in {minutes > 0 ? `${minutes}m ` : ``}
                      {`${seconds}s`}
                    </Form.Text>
                  ) : null}
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className='mb-3' controlId='amountInRupeesBB'>
                      <Form.Label>Amount in Rupees</Form.Label>
                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(bidPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='amount'
                        value={getItemValue('PRODUCT_QTY')}
                        onWheel={(e: any) => e.target.blur()}
                        onFocus={() => onItemFocus('AMOUNT')}
                        onValueChange={onChangeBuyMetal}
                        onKeyUp={doneTyping}
                        placeholder='₹ 0.00'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        prefix='₹ '
                        decimalsLimit={2}
                        decimalScale={2}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className='mb-3' controlId='amountInGramsBB'>
                      <Form.Label>Quantity in grams</Form.Label>
                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(bidPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='grams'
                        value={getItemValue('AMOUNT')}
                        onWheel={(e: any) => e.target.blur()}
                        onValueChange={onChangeBuyMetal}
                        onFocus={() => onItemFocus('PRODUCT_QTY')}
                        onKeyUp={doneTyping}
                        placeholder='0.0000 g'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        suffix=' g'
                        decimalsLimit={4}
                        decimalScale={4}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <div className='d-flex justify-content-between mb-3 mt-3 tg-btns'>
                    {item.requestedType === 'PRODUCT_QTY'
                      ? [1, 5, 10, 25].map((quantity, idx) => (
                        <Button
                          key={idx}
                          variant='outline-warning'
                          disabled={quoteLoading}
                          onClick={() =>
                            onAdditionPillClick(
                              item.requestedValueQuantity
                                ? formatAmount(
                                  Number(item.requestedValueQuantity) +
                                  Number(quantity),
                                  4
                                )
                                : formatAmount(Number(quantity), 4),
                              'grams'
                            )
                          }
                        >
                          + {quantity}g
                        </Button>
                      ))
                      : [500, 1000, 2000, 5000].map((amount, idx) => (
                        <Button
                          key={idx}
                          variant='outline-warning'
                          disabled={quoteLoading}
                          onClick={() =>
                            onAdditionPillClick(
                              item.requestedValueAmount
                                ? Number(item.requestedValueAmount) +
                                Number(amount)
                                : Number(amount),
                              'amount'
                            )
                          }
                        >
                          + ₹{amount}
                        </Button>
                      ))}
                  </div>
                </Row>

                <Form.Group className='mb-3' controlId='paymentMethodBB'>
                  <Form.Label>Payment Method</Form.Label>
                  <Form.Select
                    aria-label='Default select example'
                    onChange={onChangePaymentMethod}
                  >
                    <option value='BANK_TRANSFER'>Bank Account</option>
                  </Form.Select>
                </Form.Group>
                <div className='d-grid mb-3'>
                  <Button
                    variant='primary'
                    disabled={
                      Number(bidPrice) === 0 ||
                      customer.active === 'DISABLED' ||
                      Object.keys(selectedAccount).length === 0 ||
                      selectedAccount.active === 'DISABLED' ||
                      quoteError
                    }
                    onClick={() => checkPanRequirement(true, 'BUY')}
                    size='lg'
                  >
                    Proceed
                  </Button>
                </div>
              </Form>
            </Tab>

            {/* ══════════════════════════════════════════ MULTIMETAL TAB ══ */}
            <Tab eventKey='MULTIMETAL' title='MultiMetal'>
              <Form>
                {/* Column headers */}
                <div style={{ display: 'flex', marginBottom: '4px' }}>
                  <span
                    style={{
                      flex: '0.8',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: '#6b7280',
                      padding: '6px 8px',
                    }}
                  >
                    Metal
                  </span>
                  <span
                    style={{
                      flex: '1',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: '#6b7280',
                      textAlign: 'center',
                      padding: '6px 0',
                    }}
                  >
                    Live price
                  </span>
                  <span
                    style={{
                      flex: '1',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: '#6b7280',
                      textAlign: 'right',
                      padding: '6px 8px',
                    }}
                  >
                    Amount (₹)
                  </span>
                </div>

                {/* Timer + Price Breakdown link */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#6b7280' }}>
                    {quoteGenerated && mmCountdown
                      ? `Refreshes in ${mmCountdown}`
                      : ''}
                  </span>
                  {quoteGenerated && multiMetalSummary && (
                    <Form.Label
                      role='button'
                      ref={targetMultiMetal}
                      onClick={() =>
                        setIsPriceBreakdownShowMultiMetal(
                          !isPriceBreakdownShowMultiMetal
                        )
                      }
                      style={{
                        marginBottom: 0,
                        fontSize: '13px',
                        color: '#99834D',
                        fontWeight: 600,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Price Breakdown
                    </Form.Label>
                  )}
                </div>

                <Overlay
                  target={targetMultiMetal.current}
                  show={
                    !!targetMultiMetal.current &&
                    isPriceBreakdownShowMultiMetal &&
                    !!multiMetalSummary &&
                    quoteGenerated
                  }
                  placement={window.innerWidth >= 576 ? 'right-start' : 'top'}
                >
                  {(props) => (
                    <Popover id='popover-multimetal' {...props}>
                      <Popover.Header
                        style={{
                          background: '#301250',
                          color: '#fff',
                          fontSize: '13px',
                          fontWeight: 600,
                        }}
                      >
                        Quotation
                      </Popover.Header>
                      <Popover.Body
                        style={{ padding: '10px', fontSize: '12px' }}
                      >
                        {multiMetalSummary?.lines?.map((line, idx) => (
                          <div key={line.code}>
                            <div className='mm-va-header'>
                              <span className='mm-va-pill'>{line?.name}</span>
                              <span className='mm-va-line-total'>
                                ₹ {formatAmount(line.itemTotalAmount)}
                              </span>
                            </div>
                            <div className='mm-va-row'>
                              <span className='mm-va-key'>Quantity</span>
                              <span className='mm-va-val'>
                                {formatValue(line.qty)} g
                              </span>
                            </div>
                            <div className='mm-va-row'>
                              <span className='mm-va-key'>Line Amount</span>
                              <span className='mm-va-val'>
                                ₹ {formatAmount(line.lineAmount)}
                              </span>
                            </div>
                            {line.gst !== 0 && (
                              <div className='mm-va-row'>
                                <span className='mm-va-key'>GST</span>
                                <span className='mm-va-val'>
                                  ₹ {formatAmount(line.gst)}
                                </span>
                              </div>
                            )}
                            {line.roundingDifference !== 0 && (
                              <div className='mm-va-row'>
                                <span className='mm-va-key'>
                                  Rounding Difference
                                </span>
                                <span className='mm-va-val'>
                                  ₹ {formatAmount(line.roundingDifference)}
                                </span>
                              </div>
                            )}
                            {idx < multiMetalSummary.lines.length - 1 && (
                              <div className='mm-va-divider' />
                            )}
                          </div>
                        ))}

                        {/* {multiMetalSummary?.totalDiscount > 0 && (
                          <div className='mm-va-row' style={{ marginBottom: '4px' }}>
                            <span className='mm-va-key mm-va-green'>Instant Discount</span>
                            <span className='mm-va-val mm-va-green'>
                              - ₹ {formatAmount(multiMetalSummary.totalDiscount)}
                            </span>
                          </div>
                        )} */}
                        <div className='mm-va-grand'>
                          <span>Total</span>
                          <span>₹ {formatAmount(multiMetalSummary?.grandTotal)}</span>
                        </div>
                        {/* {multiMetalSummary?.totalCashback > 0 && (
                          <div
                            className='mm-va-row'
                            style={{ marginTop: '6px', paddingTop: '6px', borderTop: '1px dashed #e5e7eb' }}
                          >
                            <span className='mm-va-key mm-va-green' style={{ fontWeight: 600 }}>
                              Cashback
                            </span>
                            <span className='mm-va-val mm-va-green' style={{ fontWeight: 600 }}>
                              ₹ {formatAmount(multiMetalSummary.totalCashback)}
                            </span>
                          </div>
                        )} */}
                      </Popover.Body>
                    </Popover>
                  )}
                </Overlay>

                {/* Metal rows */}
                {multiMetalConfig?.map((metal) => {
                  const isActive =
                    parseFloat(
                      multiMetalAmounts[metal?.code]?.replace(/,/g, '') || '0'
                    ) > 0;
                  return (
                    <div
                      key={metal.code}
                      className={`mm-metal-row${isActive ? ' mm-metal-row--active' : ''
                        }`}
                    >
                      <div className='mm-metal-left'>
                        <span className='mm-metal-name'>{metal?.name}</span>
                      </div>
                      <div className='mm-price'>
                        {multiMetalPricesLoading ? (
                          <span
                            className='mm-price-val'
                            style={{ color: '#9ca3af' }}
                          >
                            Loading...
                          </span>
                        ) : metal?.price && Number(metal?.price) ? (
                          <span className='mm-price-val'>
                            ₹ {formatAmount(Number(metal?.price), 2)}
                            <span className='mm-price-unit'> /g</span>
                          </span>
                        ) : (
                          <span style={{ fontSize: '11px', color: '#e84040' }}>
                            Unavailable
                          </span>
                        )}
                      </div>
                      <div>
                        <CurrencyInput
                          allowNegativeValue={false}
                          className='form-control text-right mm-amount-input'
                          name={`mm-${metal.code}`}
                          value={multiMetalAmounts[metal.code]}
                          onValueChange={(val) =>
                            onChangeMultiMetalAmount(val || '', metal.code)
                          }
                          placeholder='₹ 0.00'
                          prefix='₹ '
                          disabled={isGeneratingQuote}
                          decimalsLimit={0}
                          decimalScale={0}
                          allowDecimals={false}
                        />
                      </div>
                    </div>
                  );
                })}

                {/* Total */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 8px',
                    marginTop: '4px',
                    marginBottom: '10px',
                    borderTop: '1px solid #e5e7eb',
                  }}
                >
                  <span
                    style={{
                      fontSize: '13px',
                      fontWeight: 600,
                      color: '#6b7280',
                    }}
                  >
                    Total Amount
                  </span>
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 700,
                      color: '#302B2B',
                    }}
                  >
                    ₹ {formatAmount(multiMetalTotal)}
                  </span>
                </div>

                {/* Generate Quote button */}
                {!quoteGenerated && (
                  <div className='d-grid mb-2'>
                    {/* MM applied-coupon box / apply-coupon link */}

                    <Button
                      variant='primary'
                      disabled={multiMetalTotal === 0 || isGeneratingQuote}
                      onClick={() => onGenerateMultiMetalQuote()}
                      style={{ fontSize: '14px' }}
                    >
                      {isGeneratingQuote ? (
                        <>
                          <Spinner
                            animation='border'
                            size='sm'
                            className='me-2'
                          />
                          Generating quote...
                        </>
                      ) : (
                        'Generate Quote'
                      )}
                    </Button>
                  </div>
                )}

                {showCouponBox && couponName && multiMetalPriceBreakdown ? (
                  <div className='remove-coupon-div'>
                    <div className='remove-coupon-div-text'>

                      <span>Coupon applied: {couponDisplayName}</span>

                      {couponLongDescription && (
                        <span>{couponLongDescription}</span>
                      )}

                      {(() => {
                        const instantDiscount = multiMetalPriceBreakdown.summary.itemTotalDiscount ?? 0;
                        const cashback = multiMetalPriceBreakdown.summary.itemTotalCashback ?? 0;

                        return (
                          <>
                            {instantDiscount > 0 && <span>You save: ₹{formatAmount(instantDiscount)}</span>}
                            {cashback > 0 && <span>Cashback: ₹{formatAmount(cashback)}</span>}
                            {instantDiscount === 0 && cashback === 0 && <span>Coupon applied</span>}
                          </>
                        );
                      })()}

                    </div>
                    <CloseButton
                      onClick={async () => {
                        onRemoveCoupon(); // Clear coupon state
                        toast.info('The coupon has been removed');

                        // Regenerate quote with skipCoupon=true to ignore couponName state
                        await onGenerateMultiMetalQuote(true);
                      }}
                    />
                  </div>
                ) : multiMetalTotal > 0 ? (
                  <div className='apply-coupon-text'>
                    <a
                      // The onClick for "Apply coupon code" in the MM tab — already builds itemForCoupon correctly,
                      // just needs the second arg added:
                      onClick={() => {
                        const firstActive = Object.entries(
                          multiMetalAmounts
                        ).find(
                          ([, v]) => parseFloat(v?.replace(/,/g, '') || '0') > 0
                        );
                        if (!firstActive) return;
                        const [code, val] = firstActive;
                        const metal = metals.find(
                          (m: any) => m.metalCode === code
                        );
                        const itemForCoupon = {
                          itemCode: metal.itemCode,
                          uom: 'g',
                          requestedValue: parseFloat(val.replace(/,/g, '')),
                          requestedValueAmount: parseFloat(
                            val.replace(/,/g, '')
                          ),
                          requestedValueQuantity: null,
                          requestedType: 'AMOUNT',
                          otherItems: [],
                        };
                        handleApplyCouponClick(itemForCoupon, 'MULTIMETAL'); // ← add second arg
                      }}
                    >
                      <span>Apply coupon code</span>
                    </a>
                  </div>
                ) : null}

                {/* Wallet + Payment + Buy — locked until quote is generated */}
                <div
                  style={{
                    opacity: quoteGenerated ? 1 : 0.4,
                    pointerEvents: quoteGenerated ? 'auto' : 'none',
                    transition: 'opacity 0.2s',
                  }}
                >
                  <div
                    className='container_checkbox form-control mb-2 mt-1'
                    style={{ backgroundColor: '#eae6dd' }}
                  >
                    <Form.Check
                      type='checkbox'
                      label={
                        <span
                          style={{
                            fontSize: '14px',
                            backgroundColor: '#eae6dd',
                          }}
                        >
                          Wallet Money —{' '}
                          <span style={{ color: '#99834d', fontWeight: '700' }}>
                            ₹ {formatAmount(walletBalance || 0)}
                          </span>
                        </span>
                      }
                      name='mm-pgwallet'
                      onClick={() => setUseMultiWallet(!useMultiWallet)}
                      disabled={
                        !quoteGenerated ||
                        walletBalance <= 0 ||
                        multiMetalTotal === 0
                      }
                    />
                  </div>

                  {/* Payment Method — hidden when full wallet covers it */}
                  {((useMultiWallet && multiMetalTotal > walletBalance) ||
                    !useMultiWallet) && (
                      <Form.Group className='mb-3' controlId='mmPaymentMethod'>
                        <Form.Label>Payment Method</Form.Label>
                        <Form.Select
                          value={multiMetalPaymentMethod.replace('WALLET_', '')}
                          onChange={(e) => {
                            const base = e.target.value; // 'UPI' | 'NEBK'
                            setMultiMetalPaymentMethod(
                              useMultiWallet ? `WALLET_${base}` : base
                            );
                          }}
                          disabled={!quoteGenerated}
                        >
                          <option value='UPI'>UPI</option>
                          {multiMetalTotal >= 100 && (
                            <option value='NEBK'>Net Banking</option>
                          )}
                        </Form.Select>
                      </Form.Group>
                    )}

                  <div className='d-grid mb-3 mt-2'>
                    <Button
                      variant='primary'
                      size='lg'
                      disabled={!quoteGenerated || multiMetalTotal === 0}
                      onClick={onProceedMultiMetal}
                    >
                      Buy Now
                    </Button>
                  </div>
                </div>
              </Form>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>

      <OrderSummary
        key={'odrSmrpop'}
        handleModal={onHandleSideModal}
        isShow={dislayOrderSummary}
        data={orderData}
        isPassbookRedirect={true}
        displayInvoice={
          customer?.customerCategory !== 'REGISTERED' ||
          orderData?.type !== 'BUYBACK'
        }
        displaySummary={true}
      />
    </>
  );
};

export default BuySellMetals;